/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminAdvanceTeamBody,
  AdminAdvanceTeamResponse,
  AdminOverrideMatchScoreBody,
  AdminOverrideMatchScoreResponse,
  AdminRebuildBracketBody,
  AdminRebuildBracketResponse,
  AdminReopenMatchBody,
  AdminReopenMatchResponse,
  AdminSeedTeamBody,
  AdminSeedTeamResponse,
  ApiError,
  ApplyPenaltyBody,
  BracketType,
  CancelInvitationActionResponse,
  CancelTournamentBody,
  CancelTournamentWithdrawalBody,
  CreatePayoutTableBody,
  CreateTournamentBody,
  CreateTournamentParticipantStreamBody,
  DeletePayoutTableResponse,
  DetachMatchPhotoResponse,
  DisputeMatchBody,
  DisputeResolutionResponse,
  DisqualifyTeamBody,
  DistributePrizesBody,
  DuplicateTournamentBody,
  EvidenceResponse,
  FinancialsResponse,
  ForceForfeitBody,
  GetPayoutTablesResponse,
  GetTournamentDisputesResponse,
  GetTournamentGamesResponse,
  GetTournamentMatchesResponse,
  InvitationActionResponse,
  InvitationsListResponse,
  InviteTeamMemberBody,
  JoinWaitlistBody,
  MatchDisputeFiledResponse,
  MatchLobbyResponse,
  MatchPhotoListResponse,
  MatchScheduleResponse,
  MyTournamentsResponse,
  NoShowReportResponse,
  PayoutTableResponse,
  PenaltyApplicationResponse,
  PrizeDistributionResponse,
  PromoteFromWaitlistBody,
  ReadyUpTeamResponse,
  RegisterTeamBody,
  ReportNoShowBody,
  RequestTournamentWithdrawalBody,
  RescheduleMatchBody,
  ResolveDisputeBody,
  RespondToInviteBody,
  ScoreConfirmationResponse,
  ScoreSubmissionResultResponse,
  StreamingSettingsResponse,
  SubmitScoreBody,
  SuccessMessageResponse,
  TeamDisqualificationResponse,
  TeamInvitationResponse,
  TeamJoinResponse,
  TeamLeaveResponse,
  TeamOperationResponse,
  TeamRegistrationResultResponse,
  TeamWithdrawResponse,
  Tournament,
  TournamentArchiveResponse,
  TournamentCancellationResponse,
  TournamentDetailResponse,
  TournamentDuplicateResponse,
  TournamentFinancialsExportResponse,
  TournamentPlatformsResponse,
  TournamentSettingsResponse,
  TournamentStatsResponse,
  TournamentTeamResponse,
  TournamentTeamsListResponse,
  TournamentWaitlistJoinResponse,
  TournamentWaitlistResponse,
  TournamentsListResponse,
  TransactionsListResponse,
  TransferCaptainBody,
  UnreadyTeamResponse,
  UpdatePayoutTableBody,
  UpdateTeamBody,
  UpdateTournamentBody,
  UpdateTournamentSettingsBody,
  UserTournamentHistoryResponse,
  UserTournamentProfile,
  UserTournamentTeamsResponse,
  WaitlistPromoteResponse,
  WalletResponse,
  WalletSummaryResponse,
} from '../models/index';
import {
    AdminAdvanceTeamBodyFromJSON,
    AdminAdvanceTeamBodyToJSON,
    AdminAdvanceTeamResponseFromJSON,
    AdminAdvanceTeamResponseToJSON,
    AdminOverrideMatchScoreBodyFromJSON,
    AdminOverrideMatchScoreBodyToJSON,
    AdminOverrideMatchScoreResponseFromJSON,
    AdminOverrideMatchScoreResponseToJSON,
    AdminRebuildBracketBodyFromJSON,
    AdminRebuildBracketBodyToJSON,
    AdminRebuildBracketResponseFromJSON,
    AdminRebuildBracketResponseToJSON,
    AdminReopenMatchBodyFromJSON,
    AdminReopenMatchBodyToJSON,
    AdminReopenMatchResponseFromJSON,
    AdminReopenMatchResponseToJSON,
    AdminSeedTeamBodyFromJSON,
    AdminSeedTeamBodyToJSON,
    AdminSeedTeamResponseFromJSON,
    AdminSeedTeamResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ApplyPenaltyBodyFromJSON,
    ApplyPenaltyBodyToJSON,
    BracketTypeFromJSON,
    BracketTypeToJSON,
    CancelInvitationActionResponseFromJSON,
    CancelInvitationActionResponseToJSON,
    CancelTournamentBodyFromJSON,
    CancelTournamentBodyToJSON,
    CancelTournamentWithdrawalBodyFromJSON,
    CancelTournamentWithdrawalBodyToJSON,
    CreatePayoutTableBodyFromJSON,
    CreatePayoutTableBodyToJSON,
    CreateTournamentBodyFromJSON,
    CreateTournamentBodyToJSON,
    CreateTournamentParticipantStreamBodyFromJSON,
    CreateTournamentParticipantStreamBodyToJSON,
    DeletePayoutTableResponseFromJSON,
    DeletePayoutTableResponseToJSON,
    DetachMatchPhotoResponseFromJSON,
    DetachMatchPhotoResponseToJSON,
    DisputeMatchBodyFromJSON,
    DisputeMatchBodyToJSON,
    DisputeResolutionResponseFromJSON,
    DisputeResolutionResponseToJSON,
    DisqualifyTeamBodyFromJSON,
    DisqualifyTeamBodyToJSON,
    DistributePrizesBodyFromJSON,
    DistributePrizesBodyToJSON,
    DuplicateTournamentBodyFromJSON,
    DuplicateTournamentBodyToJSON,
    EvidenceResponseFromJSON,
    EvidenceResponseToJSON,
    FinancialsResponseFromJSON,
    FinancialsResponseToJSON,
    ForceForfeitBodyFromJSON,
    ForceForfeitBodyToJSON,
    GetPayoutTablesResponseFromJSON,
    GetPayoutTablesResponseToJSON,
    GetTournamentDisputesResponseFromJSON,
    GetTournamentDisputesResponseToJSON,
    GetTournamentGamesResponseFromJSON,
    GetTournamentGamesResponseToJSON,
    GetTournamentMatchesResponseFromJSON,
    GetTournamentMatchesResponseToJSON,
    InvitationActionResponseFromJSON,
    InvitationActionResponseToJSON,
    InvitationsListResponseFromJSON,
    InvitationsListResponseToJSON,
    InviteTeamMemberBodyFromJSON,
    InviteTeamMemberBodyToJSON,
    JoinWaitlistBodyFromJSON,
    JoinWaitlistBodyToJSON,
    MatchDisputeFiledResponseFromJSON,
    MatchDisputeFiledResponseToJSON,
    MatchLobbyResponseFromJSON,
    MatchLobbyResponseToJSON,
    MatchPhotoListResponseFromJSON,
    MatchPhotoListResponseToJSON,
    MatchScheduleResponseFromJSON,
    MatchScheduleResponseToJSON,
    MyTournamentsResponseFromJSON,
    MyTournamentsResponseToJSON,
    NoShowReportResponseFromJSON,
    NoShowReportResponseToJSON,
    PayoutTableResponseFromJSON,
    PayoutTableResponseToJSON,
    PenaltyApplicationResponseFromJSON,
    PenaltyApplicationResponseToJSON,
    PrizeDistributionResponseFromJSON,
    PrizeDistributionResponseToJSON,
    PromoteFromWaitlistBodyFromJSON,
    PromoteFromWaitlistBodyToJSON,
    ReadyUpTeamResponseFromJSON,
    ReadyUpTeamResponseToJSON,
    RegisterTeamBodyFromJSON,
    RegisterTeamBodyToJSON,
    ReportNoShowBodyFromJSON,
    ReportNoShowBodyToJSON,
    RequestTournamentWithdrawalBodyFromJSON,
    RequestTournamentWithdrawalBodyToJSON,
    RescheduleMatchBodyFromJSON,
    RescheduleMatchBodyToJSON,
    ResolveDisputeBodyFromJSON,
    ResolveDisputeBodyToJSON,
    RespondToInviteBodyFromJSON,
    RespondToInviteBodyToJSON,
    ScoreConfirmationResponseFromJSON,
    ScoreConfirmationResponseToJSON,
    ScoreSubmissionResultResponseFromJSON,
    ScoreSubmissionResultResponseToJSON,
    StreamingSettingsResponseFromJSON,
    StreamingSettingsResponseToJSON,
    SubmitScoreBodyFromJSON,
    SubmitScoreBodyToJSON,
    SuccessMessageResponseFromJSON,
    SuccessMessageResponseToJSON,
    TeamDisqualificationResponseFromJSON,
    TeamDisqualificationResponseToJSON,
    TeamInvitationResponseFromJSON,
    TeamInvitationResponseToJSON,
    TeamJoinResponseFromJSON,
    TeamJoinResponseToJSON,
    TeamLeaveResponseFromJSON,
    TeamLeaveResponseToJSON,
    TeamOperationResponseFromJSON,
    TeamOperationResponseToJSON,
    TeamRegistrationResultResponseFromJSON,
    TeamRegistrationResultResponseToJSON,
    TeamWithdrawResponseFromJSON,
    TeamWithdrawResponseToJSON,
    TournamentFromJSON,
    TournamentToJSON,
    TournamentArchiveResponseFromJSON,
    TournamentArchiveResponseToJSON,
    TournamentCancellationResponseFromJSON,
    TournamentCancellationResponseToJSON,
    TournamentDetailResponseFromJSON,
    TournamentDetailResponseToJSON,
    TournamentDuplicateResponseFromJSON,
    TournamentDuplicateResponseToJSON,
    TournamentFinancialsExportResponseFromJSON,
    TournamentFinancialsExportResponseToJSON,
    TournamentPlatformsResponseFromJSON,
    TournamentPlatformsResponseToJSON,
    TournamentSettingsResponseFromJSON,
    TournamentSettingsResponseToJSON,
    TournamentStatsResponseFromJSON,
    TournamentStatsResponseToJSON,
    TournamentTeamResponseFromJSON,
    TournamentTeamResponseToJSON,
    TournamentTeamsListResponseFromJSON,
    TournamentTeamsListResponseToJSON,
    TournamentWaitlistJoinResponseFromJSON,
    TournamentWaitlistJoinResponseToJSON,
    TournamentWaitlistResponseFromJSON,
    TournamentWaitlistResponseToJSON,
    TournamentsListResponseFromJSON,
    TournamentsListResponseToJSON,
    TransactionsListResponseFromJSON,
    TransactionsListResponseToJSON,
    TransferCaptainBodyFromJSON,
    TransferCaptainBodyToJSON,
    UnreadyTeamResponseFromJSON,
    UnreadyTeamResponseToJSON,
    UpdatePayoutTableBodyFromJSON,
    UpdatePayoutTableBodyToJSON,
    UpdateTeamBodyFromJSON,
    UpdateTeamBodyToJSON,
    UpdateTournamentBodyFromJSON,
    UpdateTournamentBodyToJSON,
    UpdateTournamentSettingsBodyFromJSON,
    UpdateTournamentSettingsBodyToJSON,
    UserTournamentHistoryResponseFromJSON,
    UserTournamentHistoryResponseToJSON,
    UserTournamentProfileFromJSON,
    UserTournamentProfileToJSON,
    UserTournamentTeamsResponseFromJSON,
    UserTournamentTeamsResponseToJSON,
    WaitlistPromoteResponseFromJSON,
    WaitlistPromoteResponseToJSON,
    WalletResponseFromJSON,
    WalletResponseToJSON,
    WalletSummaryResponseFromJSON,
    WalletSummaryResponseToJSON,
} from '../models/index';

export interface CreateTournamentsRequest {
    createTournamentBody: CreateTournamentBody;
}

export interface CreateTournamentsIdCancelRequest {
    id: string;
    cancelTournamentBody?: CancelTournamentBody;
}

export interface CreateTournamentsIdDuplicateRequest {
    id: string;
    duplicateTournamentBody?: DuplicateTournamentBody;
}

export interface CreateTournamentsIdMatchesMatchIdForfeitRequest {
    id: string;
    matchId: string;
    forceForfeitBody: ForceForfeitBody;
}

export interface CreateTournamentsIdStartRequest {
    id: string;
    body?: object;
}

export interface CreateTournamentsIdTeamsRequest {
    id: string;
    adminSeedTeamBody: AdminSeedTeamBody;
}

export interface CreateTournamentsIdTeamsTeamIdPenaltyRequest {
    id: string;
    teamId: string;
    applyPenaltyBody: ApplyPenaltyBody;
}

export interface CreateTournamentsInvitationsInvitationIdCancelRequest {
    invitationId: string;
    body?: object;
}

export interface CreateTournamentsInvitationsInvitationIdResendRequest {
    invitationId: string;
    body?: object;
}

export interface CreateTournamentsInvitationsInvitationIdRespondRequest {
    invitationId: string;
    respondToInviteBody: RespondToInviteBody;
}

export interface CreateTournamentsPayoutTablesRequest {
    createPayoutTableBody: CreatePayoutTableBody;
}

export interface CreateTournamentsTournamentIdAdminRebuildBracketRequest {
    tournamentId: string;
    adminRebuildBracketBody: AdminRebuildBracketBody;
}

export interface CreateTournamentsTournamentIdDisputesDisputeIdResolveRequest {
    tournamentId: string;
    disputeId: string;
    resolveDisputeBody: ResolveDisputeBody;
}

export interface CreateTournamentsTournamentIdDistributePrizesRequest {
    tournamentId: string;
    distributePrizesBody?: DistributePrizesBody;
}

export interface CreateTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeamRequest {
    tournamentId: string;
    matchId: string;
    adminAdvanceTeamBody: AdminAdvanceTeamBody;
}

export interface CreateTournamentsTournamentIdMatchesMatchIdAdminReopenRequest {
    tournamentId: string;
    matchId: string;
    adminReopenMatchBody: AdminReopenMatchBody;
}

export interface CreateTournamentsTournamentIdMatchesMatchIdAdminScoreOverrideRequest {
    tournamentId: string;
    matchId: string;
    adminOverrideMatchScoreBody: AdminOverrideMatchScoreBody;
}

export interface CreateTournamentsTournamentIdMatchesMatchIdConfirmRequest {
    tournamentId: string;
    matchId: string;
    body?: object;
}

export interface CreateTournamentsTournamentIdMatchesMatchIdDisputeRequest {
    tournamentId: string;
    matchId: string;
    disputeMatchBody: DisputeMatchBody;
}

export interface CreateTournamentsTournamentIdMatchesMatchIdNoShowRequest {
    tournamentId: string;
    matchId: string;
    reportNoShowBody: ReportNoShowBody;
}

export interface CreateTournamentsTournamentIdMatchesMatchIdReadyRequest {
    tournamentId: string;
    matchId: string;
}

export interface CreateTournamentsTournamentIdMatchesMatchIdScoreRequest {
    tournamentId: string;
    matchId: string;
    submitScoreBody: SubmitScoreBody;
}

export interface CreateTournamentsTournamentIdParticipantStreamRequest {
    tournamentId: string;
    createTournamentParticipantStreamBody: CreateTournamentParticipantStreamBody;
}

export interface CreateTournamentsTournamentIdTeamsRequest {
    tournamentId: string;
    registerTeamBody: RegisterTeamBody;
}

export interface CreateTournamentsTournamentIdTeamsTeamIdCheckInRequest {
    tournamentId: string;
    teamId: string;
    body?: object;
}

export interface CreateTournamentsTournamentIdTeamsTeamIdDisqualifyRequest {
    tournamentId: string;
    teamId: string;
    disqualifyTeamBody: DisqualifyTeamBody;
}

export interface CreateTournamentsTournamentIdTeamsTeamIdInviteRequest {
    tournamentId: string;
    teamId: string;
    inviteTeamMemberBody: InviteTeamMemberBody;
}

export interface CreateTournamentsTournamentIdTeamsTeamIdJoinRequest {
    tournamentId: string;
    teamId: string;
    token: string;
    playerName: string;
    body?: object;
}

export interface CreateTournamentsTournamentIdTeamsTeamIdLeaveRequest {
    tournamentId: string;
    teamId: string;
    body?: object;
}

export interface CreateTournamentsTournamentIdWaitlistRequest {
    tournamentId: string;
    joinWaitlistBody: JoinWaitlistBody;
}

export interface CreateTournamentsTournamentIdWaitlistPromoteRequest {
    tournamentId: string;
    promoteFromWaitlistBody?: PromoteFromWaitlistBody;
}

export interface CreateTournamentsWalletWithdrawRequest {
    requestTournamentWithdrawalBody?: RequestTournamentWithdrawalBody;
}

export interface CreateTournamentsWalletWithdrawalsWithdrawalIdCancelRequest {
    withdrawalId: string;
    cancelTournamentWithdrawalBody?: CancelTournamentWithdrawalBody;
}

export interface DeleteTournamentsIdRequest {
    id: string;
}

export interface DeleteTournamentsPayoutTablesPayoutTableIdRequest {
    payoutTableId: string;
}

export interface DeleteTournamentsTournamentIdMatchesMatchIdReadyRequest {
    tournamentId: string;
    matchId: string;
}

export interface DeleteTournamentsTournamentIdParticipantStreamPlatformRequest {
    tournamentId: string;
    platform: DeleteTournamentsTournamentIdParticipantStreamPlatformPlatformEnum;
}

export interface DeleteTournamentsTournamentIdTeamsTeamIdMembersUserIdRequest {
    tournamentId: string;
    teamId: string;
    userId: string;
}

export interface DeleteTournamentsTournamentIdTeamsTeamIdWithdrawRequest {
    tournamentId: string;
    teamId: string;
}

export interface DeleteTournamentsTournamentIdWaitlistRequest {
    tournamentId: string;
}

export interface GetTournamentsRequest {
    status?: string;
    bracketType?: BracketType;
    gameId?: string;
    challengeId?: string;
    competitionId?: string;
    search?: string;
    startTimeFrom?: number;
    startTimeTo?: number;
    sort?: GetTournamentsSortEnum;
    order?: GetTournamentsOrderEnum;
    matchFormatType?: GetTournamentsMatchFormatTypeEnum;
    limit?: number;
    offset?: number;
    includeRegistrationClosed?: boolean;
    includeArchived?: boolean;
}

export interface GetTournamentsIdRequest {
    id: string;
}

export interface GetTournamentsIdDisputesRequest {
    id: string;
    limit?: number;
    skip?: number;
}

export interface GetTournamentsIdFinancialsRequest {
    id: string;
}

export interface GetTournamentsIdFinancialsExportRequest {
    id: string;
    format?: GetTournamentsIdFinancialsExportFormatEnum;
}

export interface GetTournamentsIdMatchesRequest {
    id: string;
    limit?: number;
    skip?: number;
}

export interface GetTournamentsIdMatchesMatchIdEvidenceRequest {
    id: string;
    matchId: string;
}

export interface GetTournamentsIdTransactionsRequest {
    id: string;
    type?: GetTournamentsIdTransactionsTypeEnum;
    limit?: number;
    offset?: number;
}

export interface GetTournamentsInvitationsRequest {
    status?: string;
    tournamentId?: string;
    teamId?: string;
    limit?: number;
    offset?: number;
}

export interface GetTournamentsPayoutTablesRequest {
    minTeams?: number;
    maxTeams?: number;
    includeDefaults?: boolean;
}

export interface GetTournamentsPayoutTablesPayoutTableIdRequest {
    payoutTableId: string;
}

export interface GetTournamentsTournamentIdMatchesMatchIdLobbyRequest {
    tournamentId: string;
    matchId: string;
}

export interface GetTournamentsTournamentIdMatchesMatchIdPhotosRequest {
    tournamentId: string;
    matchId: string;
}

export interface GetTournamentsTournamentIdTeamsRequest {
    tournamentId: string;
}

export interface GetTournamentsTournamentIdTeamsTeamIdRequest {
    tournamentId: string;
    teamId: string;
}

export interface GetTournamentsTournamentIdWaitlistRequest {
    tournamentId: string;
}

export interface GetTournamentsUsersUserIdHistoryRequest {
    userId: string;
    limit?: number;
    offset?: number;
}

export interface GetTournamentsUsersUserIdProfileRequest {
    userId: string;
}

export interface GetTournamentsUsersUserIdTeamsRequest {
    userId: string;
}

export interface GetTournamentsWalletRequest {
    limit?: number;
    offset?: number;
}

export interface UpdateTournamentsIdRequest {
    id: string;
    updateTournamentBody: UpdateTournamentBody;
}

export interface UpdateTournamentsIdMatchesMatchIdScheduleRequest {
    id: string;
    matchId: string;
    rescheduleMatchBody: RescheduleMatchBody;
}

export interface UpdateTournamentsIdTeamsTeamIdCaptainRequest {
    id: string;
    teamId: string;
    transferCaptainBody: TransferCaptainBody;
}

export interface UpdateTournamentsPayoutTablesPayoutTableIdRequest {
    payoutTableId: string;
    updatePayoutTableBody: UpdatePayoutTableBody;
}

export interface UpdateTournamentsSettingsRequest {
    updateTournamentSettingsBody: UpdateTournamentSettingsBody;
}

export interface UpdateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetachRequest {
    tournamentId: string;
    matchId: string;
    photoId: string;
}

export interface UpdateTournamentsTournamentIdTeamsTeamIdRequest {
    tournamentId: string;
    teamId: string;
    updateTeamBody: UpdateTeamBody;
}

/**
 * TournamentsApi - interface
 * 
 * @export
 * @interface TournamentsApiInterface
 */
export interface TournamentsApiInterface {
    /**
     * Create a new tournament (admin only)
     * @param {CreateTournamentBody} createTournamentBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsRaw(requestParameters: CreateTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tournament>>;

    /**
     * Create a new tournament (admin only)
     */
    createTournaments(requestParameters: CreateTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tournament>;

    /**
     * Cancel a tournament and optionally refund entry fees (admin only). Rejected if the tournament has already paid out prizes; a COMPLETED tournament that paid no one is cancellable so its entry fees can be refunded.
     * @param {string} id Tournament ID
     * @param {CancelTournamentBody} [cancelTournamentBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsIdCancelRaw(requestParameters: CreateTournamentsIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentCancellationResponse>>;

    /**
     * Cancel a tournament and optionally refund entry fees (admin only). Rejected if the tournament has already paid out prizes; a COMPLETED tournament that paid no one is cancellable so its entry fees can be refunded.
     */
    createTournamentsIdCancel(requestParameters: CreateTournamentsIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentCancellationResponse>;

    /**
     * Duplicate an existing tournament with new timing (admin only)
     * @param {string} id Tournament ID to duplicate
     * @param {DuplicateTournamentBody} [duplicateTournamentBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsIdDuplicateRaw(requestParameters: CreateTournamentsIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentDuplicateResponse>>;

    /**
     * Duplicate an existing tournament with new timing (admin only)
     */
    createTournamentsIdDuplicate(requestParameters: CreateTournamentsIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentDuplicateResponse>;

    /**
     * Force forfeit a match for a team (admin only)
     * @param {string} id Tournament ID
     * @param {string} matchId Match ID
     * @param {ForceForfeitBody} forceForfeitBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsIdMatchesMatchIdForfeitRaw(requestParameters: CreateTournamentsIdMatchesMatchIdForfeitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentArchiveResponse>>;

    /**
     * Force forfeit a match for a team (admin only)
     */
    createTournamentsIdMatchesMatchIdForfeit(requestParameters: CreateTournamentsIdMatchesMatchIdForfeitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentArchiveResponse>;

    /**
     * Start a tournament and generate brackets (admin only). Automatically locks rosters if not already locked to prevent roster changes during play.
     * @param {string} id Tournament ID
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsIdStartRaw(requestParameters: CreateTournamentsIdStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tournament>>;

    /**
     * Start a tournament and generate brackets (admin only). Automatically locks rosters if not already locked to prevent roster changes during play.
     */
    createTournamentsIdStart(requestParameters: CreateTournamentsIdStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tournament>;

    /**
     * Admin-create a team for seeding or placeholders (admin only)
     * @param {string} id Tournament ID
     * @param {AdminSeedTeamBody} adminSeedTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsIdTeamsRaw(requestParameters: CreateTournamentsIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminSeedTeamResponse>>;

    /**
     * Admin-create a team for seeding or placeholders (admin only)
     */
    createTournamentsIdTeams(requestParameters: CreateTournamentsIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminSeedTeamResponse>;

    /**
     * Apply a penalty to a team (admin only)
     * @param {string} id Tournament ID
     * @param {string} teamId Team ID
     * @param {ApplyPenaltyBody} applyPenaltyBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsIdTeamsTeamIdPenaltyRaw(requestParameters: CreateTournamentsIdTeamsTeamIdPenaltyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PenaltyApplicationResponse>>;

    /**
     * Apply a penalty to a team (admin only)
     */
    createTournamentsIdTeamsTeamIdPenalty(requestParameters: CreateTournamentsIdTeamsTeamIdPenaltyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PenaltyApplicationResponse>;

    /**
     * Cancel a pending team invitation (admin only)
     * @param {string} invitationId 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsInvitationsInvitationIdCancelRaw(requestParameters: CreateTournamentsInvitationsInvitationIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelInvitationActionResponse>>;

    /**
     * Cancel a pending team invitation (admin only)
     */
    createTournamentsInvitationsInvitationIdCancel(requestParameters: CreateTournamentsInvitationsInvitationIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelInvitationActionResponse>;

    /**
     * Resend a team invitation (admin only). Resets expiration and can be used for expired invitations.
     * @param {string} invitationId 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsInvitationsInvitationIdResendRaw(requestParameters: CreateTournamentsInvitationsInvitationIdResendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvitationActionResponse>>;

    /**
     * Resend a team invitation (admin only). Resets expiration and can be used for expired invitations.
     */
    createTournamentsInvitationsInvitationIdResend(requestParameters: CreateTournamentsInvitationsInvitationIdResendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvitationActionResponse>;

    /**
     * Accept or decline a team invitation
     * @param {string} invitationId 
     * @param {RespondToInviteBody} respondToInviteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsInvitationsInvitationIdRespondRaw(requestParameters: CreateTournamentsInvitationsInvitationIdRespondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamOperationResponse>>;

    /**
     * Accept or decline a team invitation
     */
    createTournamentsInvitationsInvitationIdRespond(requestParameters: CreateTournamentsInvitationsInvitationIdRespondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamOperationResponse>;

    /**
     * Create a new payout table (admin only)
     * @param {CreatePayoutTableBody} createPayoutTableBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsPayoutTablesRaw(requestParameters: CreateTournamentsPayoutTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayoutTableResponse>>;

    /**
     * Create a new payout table (admin only)
     */
    createTournamentsPayoutTables(requestParameters: CreateTournamentsPayoutTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayoutTableResponse>;

    /**
     * Regenerate the tournament bracket from the current paid, active team list and seeds. Pre-play only — refuses the moment any match has readied into play or recorded a score.
     * @param {string} tournamentId 
     * @param {AdminRebuildBracketBody} adminRebuildBracketBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdAdminRebuildBracketRaw(requestParameters: CreateTournamentsTournamentIdAdminRebuildBracketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminRebuildBracketResponse>>;

    /**
     * Regenerate the tournament bracket from the current paid, active team list and seeds. Pre-play only — refuses the moment any match has readied into play or recorded a score.
     */
    createTournamentsTournamentIdAdminRebuildBracket(requestParameters: CreateTournamentsTournamentIdAdminRebuildBracketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminRebuildBracketResponse>;

    /**
     * Resolve a match dispute (admin only)
     * @param {string} tournamentId 
     * @param {string} disputeId 
     * @param {ResolveDisputeBody} resolveDisputeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdDisputesDisputeIdResolveRaw(requestParameters: CreateTournamentsTournamentIdDisputesDisputeIdResolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DisputeResolutionResponse>>;

    /**
     * Resolve a match dispute (admin only)
     */
    createTournamentsTournamentIdDisputesDisputeIdResolve(requestParameters: CreateTournamentsTournamentIdDisputesDisputeIdResolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DisputeResolutionResponse>;

    /**
     * Distribute prizes to tournament winners (admin only)
     * @param {string} tournamentId 
     * @param {DistributePrizesBody} [distributePrizesBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdDistributePrizesRaw(requestParameters: CreateTournamentsTournamentIdDistributePrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrizeDistributionResponse>>;

    /**
     * Distribute prizes to tournament winners (admin only)
     */
    createTournamentsTournamentIdDistributePrizes(requestParameters: CreateTournamentsTournamentIdDistributePrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrizeDistributionResponse>;

    /**
     * Admin manually advances one of a match\'s teams into its next bracket slot — the escape hatch for a stuck pairing. Completes the match with an explicit winner and no scores. Refuses completed and disputed matches.
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {AdminAdvanceTeamBody} adminAdvanceTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeamRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminAdvanceTeamResponse>>;

    /**
     * Admin manually advances one of a match\'s teams into its next bracket slot — the escape hatch for a stuck pairing. Completes the match with an explicit winner and no scores. Refuses completed and disputed matches.
     */
    createTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeam(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminAdvanceTeamResponse>;

    /**
     * Reopen a decided match, clearing its result and unseating the winner from the next round (admin only).
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {AdminReopenMatchBody} adminReopenMatchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdMatchesMatchIdAdminReopenRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminReopenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminReopenMatchResponse>>;

    /**
     * Reopen a decided match, clearing its result and unseating the winner from the next round (admin only).
     */
    createTournamentsTournamentIdMatchesMatchIdAdminReopen(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminReopenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminReopenMatchResponse>;

    /**
     * Admin sets a match result directly — no dispute required. IN_PROGRESS and AWAITING_CONFIRMATION matches only; a COMPLETED match needs the (separate) reopen flow and a DISPUTED one goes through dispute resolution.
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {AdminOverrideMatchScoreBody} adminOverrideMatchScoreBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdMatchesMatchIdAdminScoreOverrideRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminScoreOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOverrideMatchScoreResponse>>;

    /**
     * Admin sets a match result directly — no dispute required. IN_PROGRESS and AWAITING_CONFIRMATION matches only; a COMPLETED match needs the (separate) reopen flow and a DISPUTED one goes through dispute resolution.
     */
    createTournamentsTournamentIdMatchesMatchIdAdminScoreOverride(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminScoreOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOverrideMatchScoreResponse>;

    /**
     * Confirm the standing score for your team (team captain only). The match completes once both teams have confirmed — a manual submission counts as the submitter\'s confirmation, a machine pre-fill counts for neither.
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdMatchesMatchIdConfirmRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScoreConfirmationResponse>>;

    /**
     * Confirm the standing score for your team (team captain only). The match completes once both teams have confirmed — a manual submission counts as the submitter\'s confirmation, a machine pre-fill counts for neither.
     */
    createTournamentsTournamentIdMatchesMatchIdConfirm(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScoreConfirmationResponse>;

    /**
     * Dispute a match score submission (team captain only)
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {DisputeMatchBody} disputeMatchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdMatchesMatchIdDisputeRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdDisputeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchDisputeFiledResponse>>;

    /**
     * Dispute a match score submission (team captain only)
     */
    createTournamentsTournamentIdMatchesMatchIdDispute(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdDisputeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchDisputeFiledResponse>;

    /**
     * Report opponent as no-show once the configured no-show window (TournamentTimerConfig.noShowWindowMinutes, default 15) has elapsed since the scheduled match time. Results in automatic forfeit.
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {ReportNoShowBody} reportNoShowBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdMatchesMatchIdNoShowRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdNoShowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NoShowReportResponse>>;

    /**
     * Report opponent as no-show once the configured no-show window (TournamentTimerConfig.noShowWindowMinutes, default 15) has elapsed since the scheduled match time. Results in automatic forfeit.
     */
    createTournamentsTournamentIdMatchesMatchIdNoShow(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdNoShowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NoShowReportResponse>;

    /**
     * Mark the caller\'s team as ready for a bracket match (team captain only). When both teams are ready the match moves IN_PROGRESS and score submission opens.
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdMatchesMatchIdReadyRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdReadyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadyUpTeamResponse>>;

    /**
     * Mark the caller\'s team as ready for a bracket match (team captain only). When both teams are ready the match moves IN_PROGRESS and score submission opens.
     */
    createTournamentsTournamentIdMatchesMatchIdReady(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdReadyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadyUpTeamResponse>;

    /**
     * Submit match score (team captain only)
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {SubmitScoreBody} submitScoreBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdMatchesMatchIdScoreRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScoreSubmissionResultResponse>>;

    /**
     * Submit match score (team captain only)
     */
    createTournamentsTournamentIdMatchesMatchIdScore(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScoreSubmissionResultResponse>;

    /**
     * Participant toggles their own connected channel on for the tournament. No channel id — resolved from the caller\'s ACTIVE UserExternalIdentity. Requires the caller to be a tournament participant and the competition streamingMode to be INDIVIDUAL or BOTH.
     * @param {string} tournamentId 
     * @param {CreateTournamentParticipantStreamBody} createTournamentParticipantStreamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdParticipantStreamRaw(requestParameters: CreateTournamentsTournamentIdParticipantStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettingsResponse>>;

    /**
     * Participant toggles their own connected channel on for the tournament. No channel id — resolved from the caller\'s ACTIVE UserExternalIdentity. Requires the caller to be a tournament participant and the competition streamingMode to be INDIVIDUAL or BOTH.
     */
    createTournamentsTournamentIdParticipantStream(requestParameters: CreateTournamentsTournamentIdParticipantStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettingsResponse>;

    /**
     * Register a new team for a tournament (creates team with user as captain)
     * @param {string} tournamentId Tournament ID
     * @param {RegisterTeamBody} registerTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdTeamsRaw(requestParameters: CreateTournamentsTournamentIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamRegistrationResultResponse>>;

    /**
     * Register a new team for a tournament (creates team with user as captain)
     */
    createTournamentsTournamentIdTeams(requestParameters: CreateTournamentsTournamentIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamRegistrationResultResponse>;

    /**
     * Check in a team for tournament. Must be within check-in window (startTime - checkInWindowMinutes to startTime).
     * @param {string} tournamentId Tournament ID
     * @param {string} teamId Team ID
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdTeamsTeamIdCheckInRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdCheckInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamOperationResponse>>;

    /**
     * Check in a team for tournament. Must be within check-in window (startTime - checkInWindowMinutes to startTime).
     */
    createTournamentsTournamentIdTeamsTeamIdCheckIn(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdCheckInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamOperationResponse>;

    /**
     * Disqualify a team from the tournament (admin only)
     * @param {string} tournamentId 
     * @param {string} teamId 
     * @param {DisqualifyTeamBody} disqualifyTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdTeamsTeamIdDisqualifyRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdDisqualifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamDisqualificationResponse>>;

    /**
     * Disqualify a team from the tournament (admin only)
     */
    createTournamentsTournamentIdTeamsTeamIdDisqualify(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdDisqualifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamDisqualificationResponse>;

    /**
     * Invite a user to join the team (captain only)
     * @param {string} tournamentId 
     * @param {string} teamId 
     * @param {InviteTeamMemberBody} inviteTeamMemberBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdTeamsTeamIdInviteRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamInvitationResponse>>;

    /**
     * Invite a user to join the team (captain only)
     */
    createTournamentsTournamentIdTeamsTeamIdInvite(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamInvitationResponse>;

    /**
     * Allows a user to join a team directly via an invite link. This is a self-service join - users with the invite token can add themselves to the team roster without requiring captain approval. The invite token is provided by the team captain and must be passed as a query parameter. 
     * @summary Join a team via invite link
     * @param {string} tournamentId Tournament ID
     * @param {string} teamId Team ID
     * @param {string} token Team invite token (provided by captain)
     * @param {string} playerName Player\&#39;s in-game name that will be displayed
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdTeamsTeamIdJoinRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamJoinResponse>>;

    /**
     * Allows a user to join a team directly via an invite link. This is a self-service join - users with the invite token can add themselves to the team roster without requiring captain approval. The invite token is provided by the team captain and must be passed as a query parameter. 
     * Join a team via invite link
     */
    createTournamentsTournamentIdTeamsTeamIdJoin(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamJoinResponse>;

    /**
     * Leave a team (cannot leave if captain without transferring captaincy)
     * @param {string} tournamentId 
     * @param {string} teamId 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdTeamsTeamIdLeaveRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamLeaveResponse>>;

    /**
     * Leave a team (cannot leave if captain without transferring captaincy)
     */
    createTournamentsTournamentIdTeamsTeamIdLeave(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamLeaveResponse>;

    /**
     * Join the waitlist for a full tournament (creates team on waitlist)
     * @param {string} tournamentId Tournament ID
     * @param {JoinWaitlistBody} joinWaitlistBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdWaitlistRaw(requestParameters: CreateTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentWaitlistJoinResponse>>;

    /**
     * Join the waitlist for a full tournament (creates team on waitlist)
     */
    createTournamentsTournamentIdWaitlist(requestParameters: CreateTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentWaitlistJoinResponse>;

    /**
     * Admin endpoint to manually promote a team from waitlist
     * @param {string} tournamentId Tournament ID
     * @param {PromoteFromWaitlistBody} [promoteFromWaitlistBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsTournamentIdWaitlistPromoteRaw(requestParameters: CreateTournamentsTournamentIdWaitlistPromoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WaitlistPromoteResponse>>;

    /**
     * Admin endpoint to manually promote a team from waitlist
     */
    createTournamentsTournamentIdWaitlistPromote(requestParameters: CreateTournamentsTournamentIdWaitlistPromoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WaitlistPromoteResponse>;

    /**
     * [DEPRECATED] Request a withdrawal from tournament wallet. Not implemented - use platform rewards instead.
     * @param {RequestTournamentWithdrawalBody} [requestTournamentWithdrawalBody] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsWalletWithdrawRaw(requestParameters: CreateTournamentsWalletWithdrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * [DEPRECATED] Request a withdrawal from tournament wallet. Not implemented - use platform rewards instead.
     * @deprecated
     */
    createTournamentsWalletWithdraw(requestParameters: CreateTournamentsWalletWithdrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * [DEPRECATED] Cancel a pending withdrawal request. Not implemented.
     * @param {string} withdrawalId 
     * @param {CancelTournamentWithdrawalBody} [cancelTournamentWithdrawalBody] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentsWalletWithdrawalsWithdrawalIdCancelRaw(requestParameters: CreateTournamentsWalletWithdrawalsWithdrawalIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * [DEPRECATED] Cancel a pending withdrawal request. Not implemented.
     * @deprecated
     */
    createTournamentsWalletWithdrawalsWithdrawalIdCancel(requestParameters: CreateTournamentsWalletWithdrawalsWithdrawalIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Archive (soft delete) a tournament (admin only). Only completed or cancelled tournaments can be archived.
     * @param {string} id Tournament ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteTournamentsIdRaw(requestParameters: DeleteTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentArchiveResponse>>;

    /**
     * Archive (soft delete) a tournament (admin only). Only completed or cancelled tournaments can be archived.
     */
    deleteTournamentsId(requestParameters: DeleteTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentArchiveResponse>;

    /**
     * Delete a payout table (admin only)
     * @param {string} payoutTableId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteTournamentsPayoutTablesPayoutTableIdRaw(requestParameters: DeleteTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeletePayoutTableResponse>>;

    /**
     * Delete a payout table (admin only)
     */
    deleteTournamentsPayoutTablesPayoutTableId(requestParameters: DeleteTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeletePayoutTableResponse>;

    /**
     * Withdraw the caller\'s team ready-up for a bracket match (team captain only). Allowed only while the match is still awaiting ready-up.
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteTournamentsTournamentIdMatchesMatchIdReadyRaw(requestParameters: DeleteTournamentsTournamentIdMatchesMatchIdReadyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnreadyTeamResponse>>;

    /**
     * Withdraw the caller\'s team ready-up for a bracket match (team captain only). Allowed only while the match is still awaiting ready-up.
     */
    deleteTournamentsTournamentIdMatchesMatchIdReady(requestParameters: DeleteTournamentsTournamentIdMatchesMatchIdReadyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnreadyTeamResponse>;

    /**
     * Participant toggles their own connected channel off for the tournament. Removes only the caller\'s own featured stream for the given platform.
     * @param {string} tournamentId 
     * @param {'TWITCH' | 'KICK' | 'YOUTUBE'} platform 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteTournamentsTournamentIdParticipantStreamPlatformRaw(requestParameters: DeleteTournamentsTournamentIdParticipantStreamPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettingsResponse>>;

    /**
     * Participant toggles their own connected channel off for the tournament. Removes only the caller\'s own featured stream for the given platform.
     */
    deleteTournamentsTournamentIdParticipantStreamPlatform(requestParameters: DeleteTournamentsTournamentIdParticipantStreamPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettingsResponse>;

    /**
     * Remove a member from the team (captain only). Not allowed once tournament is IN_PROGRESS or later.
     * @param {string} tournamentId 
     * @param {string} teamId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteTournamentsTournamentIdTeamsTeamIdMembersUserIdRaw(requestParameters: DeleteTournamentsTournamentIdTeamsTeamIdMembersUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a member from the team (captain only). Not allowed once tournament is IN_PROGRESS or later.
     */
    deleteTournamentsTournamentIdTeamsTeamIdMembersUserId(requestParameters: DeleteTournamentsTournamentIdTeamsTeamIdMembersUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Withdraw entire team from tournament (captain only). Refunds entry fee if applicable based on refund policy.
     * @param {string} tournamentId 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteTournamentsTournamentIdTeamsTeamIdWithdrawRaw(requestParameters: DeleteTournamentsTournamentIdTeamsTeamIdWithdrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamWithdrawResponse>>;

    /**
     * Withdraw entire team from tournament (captain only). Refunds entry fee if applicable based on refund policy.
     */
    deleteTournamentsTournamentIdTeamsTeamIdWithdraw(requestParameters: DeleteTournamentsTournamentIdTeamsTeamIdWithdrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamWithdrawResponse>;

    /**
     * Leave the waitlist for a tournament (removes team)
     * @param {string} tournamentId Tournament ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteTournamentsTournamentIdWaitlistRaw(requestParameters: DeleteTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessMessageResponse>>;

    /**
     * Leave the waitlist for a tournament (removes team)
     */
    deleteTournamentsTournamentIdWaitlist(requestParameters: DeleteTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessMessageResponse>;

    /**
     * Get list of tournaments with optional filters
     * @param {string} [status] Filter by tournament status (can be comma-separated for multiple). DRAFT is admin-only — anonymous and non-admin callers never receive draft tournaments, whether or not they ask for them. 
     * @param {BracketType} [bracketType] Filter by bracket type (SINGLE_ELIMINATION, DOUBLE_ELIMINATION, etc.)
     * @param {string} [gameId] Filter by game ID
     * @param {string} [challengeId] Filter by parent challenge ID
     * @param {string} [competitionId] Filter by parent competition ID
     * @param {string} [search] Search tournaments by name (case-insensitive)
     * @param {number} [startTimeFrom] Filter tournaments with startTime &gt;&#x3D; this value (epoch milliseconds)
     * @param {number} [startTimeTo] Filter tournaments with startTime &lt;&#x3D; this value (epoch milliseconds)
     * @param {'startTime' | 'registeredTeamsCount' | 'entryFee' | 'createdAt' | 'name'} [sort] Field to sort by (startTime, registeredTeamsCount, entryFee, createdAt, name)
     * @param {'asc' | 'desc'} [order] Sort order (asc or desc)
     * @param {1 | 2 | 3 | 4} [matchFormatType] Filter by Match Mode\&#39;s competition type (1&#x3D;MATCH, 2&#x3D;TOURNAMENT, 3&#x3D;BRACKET, 4&#x3D;ROUND_ROBIN)
     * @param {number} [limit] Number of results to return (default 20, max 100)
     * @param {number} [offset] Pagination offset
     * @param {boolean} [includeRegistrationClosed] Include tournaments where registration has closed
     * @param {boolean} [includeArchived] Include archived tournaments. Admin-only — ignored for anonymous and non-admin callers. Archiving is a soft delete that leaves &#x60;status&#x60; untouched, so archived tournaments are excluded by default. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsRaw(requestParameters: GetTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentsListResponse>>;

    /**
     * Get list of tournaments with optional filters
     */
    getTournaments(requestParameters: GetTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentsListResponse>;

    /**
     * Get list of tournament-supported games for display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsGamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTournamentGamesResponse>>;

    /**
     * Get list of tournament-supported games for display
     */
    getTournamentsGames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTournamentGamesResponse>;

    /**
     * Get tournament details by ID
     * @param {string} id Tournament ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsIdRaw(requestParameters: GetTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentDetailResponse>>;

    /**
     * Get tournament details by ID
     */
    getTournamentsId(requestParameters: GetTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentDetailResponse>;

    /**
     * Get disputes for a tournament (admin only)
     * @param {string} id 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsIdDisputesRaw(requestParameters: GetTournamentsIdDisputesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTournamentDisputesResponse>>;

    /**
     * Get disputes for a tournament (admin only)
     */
    getTournamentsIdDisputes(requestParameters: GetTournamentsIdDisputesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTournamentDisputesResponse>;

    /**
     * Get financial summary for a tournament (admin only)
     * @param {string} id Tournament ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsIdFinancialsRaw(requestParameters: GetTournamentsIdFinancialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialsResponse>>;

    /**
     * Get financial summary for a tournament (admin only)
     */
    getTournamentsIdFinancials(requestParameters: GetTournamentsIdFinancialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialsResponse>;

    /**
     * Export tournament financial data
     * @param {string} id Tournament ID
     * @param {'json' | 'csv'} [format] Export format (json or csv)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsIdFinancialsExportRaw(requestParameters: GetTournamentsIdFinancialsExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentFinancialsExportResponse>>;

    /**
     * Export tournament financial data
     */
    getTournamentsIdFinancialsExport(requestParameters: GetTournamentsIdFinancialsExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentFinancialsExportResponse>;

    /**
     * Get all matches for a tournament (admin only). Returns the shared MatchModel reporting docs (one per bracket match, seeded at tournament start), so every playable match is visible and actionable before any score is submitted.
     * @param {string} id 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsIdMatchesRaw(requestParameters: GetTournamentsIdMatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTournamentMatchesResponse>>;

    /**
     * Get all matches for a tournament (admin only). Returns the shared MatchModel reporting docs (one per bracket match, seeded at tournament start), so every playable match is visible and actionable before any score is submitted.
     */
    getTournamentsIdMatches(requestParameters: GetTournamentsIdMatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTournamentMatchesResponse>;

    /**
     * Get all evidence for a match — score submissions with attribution, Overwolf verification, stored screenshots (with any dispute-adjudication parses), and disputes
     * @param {string} id Tournament ID
     * @param {string} matchId Match ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsIdMatchesMatchIdEvidenceRaw(requestParameters: GetTournamentsIdMatchesMatchIdEvidenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EvidenceResponse>>;

    /**
     * Get all evidence for a match — score submissions with attribution, Overwolf verification, stored screenshots (with any dispute-adjudication parses), and disputes
     */
    getTournamentsIdMatchesMatchIdEvidence(requestParameters: GetTournamentsIdMatchesMatchIdEvidenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EvidenceResponse>;

    /**
     * Get all transactions for a tournament (admin only)
     * @param {string} id Tournament ID
     * @param {'entry_fee' | 'refund' | 'prize' | 'penalty'} [type] Filter by transaction type
     * @param {number} [limit] Maximum results (default 50)
     * @param {number} [offset] Skip results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsIdTransactionsRaw(requestParameters: GetTournamentsIdTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionsListResponse>>;

    /**
     * Get all transactions for a tournament (admin only)
     */
    getTournamentsIdTransactions(requestParameters: GetTournamentsIdTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionsListResponse>;

    /**
     * Get list of team invitations with optional filters (admin only)
     * @param {string} [status] Filter by invitation status
     * @param {string} [tournamentId] Filter by tournament ID
     * @param {string} [teamId] Filter by team ID
     * @param {number} [limit] Number of results to return (default 50, max 100)
     * @param {number} [offset] Pagination offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsInvitationsRaw(requestParameters: GetTournamentsInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvitationsListResponse>>;

    /**
     * Get list of team invitations with optional filters (admin only)
     */
    getTournamentsInvitations(requestParameters: GetTournamentsInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvitationsListResponse>;

    /**
     * Get current user\'s tournaments (active, past) and pending invitations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsMyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyTournamentsResponse>>;

    /**
     * Get current user\'s tournaments (active, past) and pending invitations
     */
    getTournamentsMy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyTournamentsResponse>;

    /**
     * Get all payout tables (admin only)
     * @param {number} [minTeams] Filter by minimum team count
     * @param {number} [maxTeams] Filter by maximum team count
     * @param {boolean} [includeDefaults] Include system default templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsPayoutTablesRaw(requestParameters: GetTournamentsPayoutTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayoutTablesResponse>>;

    /**
     * Get all payout tables (admin only)
     */
    getTournamentsPayoutTables(requestParameters: GetTournamentsPayoutTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayoutTablesResponse>;

    /**
     * Get a specific payout table
     * @param {string} payoutTableId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsPayoutTablesPayoutTableIdRaw(requestParameters: GetTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayoutTableResponse>>;

    /**
     * Get a specific payout table
     */
    getTournamentsPayoutTablesPayoutTableId(requestParameters: GetTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayoutTableResponse>;

    /**
     * Get enabled tournament platforms (public endpoint)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsPlatformsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentPlatformsResponse>>;

    /**
     * Get enabled tournament platforms (public endpoint)
     */
    getTournamentsPlatforms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentPlatformsResponse>;

    /**
     * Get tournament configuration settings (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSettingsResponse>>;

    /**
     * Get tournament configuration settings (admin only)
     */
    getTournamentsSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSettingsResponse>;

    /**
     * Get aggregate tournament stats for the admin dashboard (admin only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentStatsResponse>>;

    /**
     * Get aggregate tournament stats for the admin dashboard (admin only)
     */
    getTournamentsStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentStatsResponse>;

    /**
     * Resolve a bracket match\'s lobby view — both teams\' rosters with per-member presence, team readiness, the game\'s lobby-join instructions, (for participants only) the generated lobby name/password, and the running auto-score while the match is in progress. Host = participant1 (the team on the left).
     * @param {string} tournamentId 
     * @param {string} matchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsTournamentIdMatchesMatchIdLobbyRaw(requestParameters: GetTournamentsTournamentIdMatchesMatchIdLobbyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchLobbyResponse>>;

    /**
     * Resolve a bracket match\'s lobby view — both teams\' rosters with per-member presence, team readiness, the game\'s lobby-join instructions, (for participants only) the generated lobby name/password, and the running auto-score while the match is in progress. Host = participant1 (the team on the left).
     */
    getTournamentsTournamentIdMatchesMatchIdLobby(requestParameters: GetTournamentsTournamentIdMatchesMatchIdLobbyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchLobbyResponse>;

    /**
     * List the stored screenshots for a match. Restricted to members of the two competing teams — used by the dispute filing modal to show captured scoreboard evidence.
     * @param {string} tournamentId Tournament ID
     * @param {string} matchId Bracket match ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsTournamentIdMatchesMatchIdPhotosRaw(requestParameters: GetTournamentsTournamentIdMatchesMatchIdPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchPhotoListResponse>>;

    /**
     * List the stored screenshots for a match. Restricted to members of the two competing teams — used by the dispute filing modal to show captured scoreboard evidence.
     */
    getTournamentsTournamentIdMatchesMatchIdPhotos(requestParameters: GetTournamentsTournamentIdMatchesMatchIdPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchPhotoListResponse>;

    /**
     * Get all teams registered for a tournament, including full roster and stats
     * @summary Get tournament teams
     * @param {string} tournamentId Tournament ID (MongoDB ObjectId)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsTournamentIdTeamsRaw(requestParameters: GetTournamentsTournamentIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentTeamsListResponse>>;

    /**
     * Get all teams registered for a tournament, including full roster and stats
     * Get tournament teams
     */
    getTournamentsTournamentIdTeams(requestParameters: GetTournamentsTournamentIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentTeamsListResponse>;

    /**
     * Get team details
     * @param {string} tournamentId 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsTournamentIdTeamsTeamIdRaw(requestParameters: GetTournamentsTournamentIdTeamsTeamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentTeamResponse>>;

    /**
     * Get team details
     */
    getTournamentsTournamentIdTeamsTeamId(requestParameters: GetTournamentsTournamentIdTeamsTeamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentTeamResponse>;

    /**
     * Get the waitlist for a tournament
     * @param {string} tournamentId Tournament ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsTournamentIdWaitlistRaw(requestParameters: GetTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentWaitlistResponse>>;

    /**
     * Get the waitlist for a tournament
     */
    getTournamentsTournamentIdWaitlist(requestParameters: GetTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentWaitlistResponse>;

    /**
     * Get a user\'s tournament transaction history (entry fees, prizes, refunds). Users may only retrieve their own history.
     * @param {string} userId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsUsersUserIdHistoryRaw(requestParameters: GetTournamentsUsersUserIdHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserTournamentHistoryResponse>>;

    /**
     * Get a user\'s tournament transaction history (entry fees, prizes, refunds). Users may only retrieve their own history.
     */
    getTournamentsUsersUserIdHistory(requestParameters: GetTournamentsUsersUserIdHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserTournamentHistoryResponse>;

    /**
     * Get a user\'s public tournament profile including aggregated stats
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsUsersUserIdProfileRaw(requestParameters: GetTournamentsUsersUserIdProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserTournamentProfile>>;

    /**
     * Get a user\'s public tournament profile including aggregated stats
     */
    getTournamentsUsersUserIdProfile(requestParameters: GetTournamentsUsersUserIdProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserTournamentProfile>;

    /**
     * Get all tournament teams a user is a member of
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsUsersUserIdTeamsRaw(requestParameters: GetTournamentsUsersUserIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserTournamentTeamsResponse>>;

    /**
     * Get all tournament teams a user is a member of
     */
    getTournamentsUsersUserIdTeams(requestParameters: GetTournamentsUsersUserIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserTournamentTeamsResponse>;

    /**
     * Get user\'s Fuel balance and tournament-related transaction history
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsWalletRaw(requestParameters: GetTournamentsWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WalletResponse>>;

    /**
     * Get user\'s Fuel balance and tournament-related transaction history
     */
    getTournamentsWallet(requestParameters: GetTournamentsWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WalletResponse>;

    /**
     * Get a quick summary of user\'s Fuel balance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsWalletSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WalletSummaryResponse>>;

    /**
     * Get a quick summary of user\'s Fuel balance
     */
    getTournamentsWalletSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WalletSummaryResponse>;

    /**
     * [DEPRECATED] Get user\'s withdrawal request history. Not implemented.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsWalletWithdrawalsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * [DEPRECATED] Get user\'s withdrawal request history. Not implemented.
     * @deprecated
     */
    getTournamentsWalletWithdrawals(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Update tournament details (admin only, limited fields after registration starts)
     * @param {string} id Tournament ID
     * @param {UpdateTournamentBody} updateTournamentBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentsIdRaw(requestParameters: UpdateTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tournament>>;

    /**
     * Update tournament details (admin only, limited fields after registration starts)
     */
    updateTournamentsId(requestParameters: UpdateTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tournament>;

    /**
     * Reschedule a match to a new time (admin only)
     * @param {string} id Tournament ID
     * @param {string} matchId Match ID
     * @param {RescheduleMatchBody} rescheduleMatchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentsIdMatchesMatchIdScheduleRaw(requestParameters: UpdateTournamentsIdMatchesMatchIdScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchScheduleResponse>>;

    /**
     * Reschedule a match to a new time (admin only)
     */
    updateTournamentsIdMatchesMatchIdSchedule(requestParameters: UpdateTournamentsIdMatchesMatchIdScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchScheduleResponse>;

    /**
     * Transfer team captaincy to another member (admin only)
     * @param {string} id Tournament ID
     * @param {string} teamId Team ID
     * @param {TransferCaptainBody} transferCaptainBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentsIdTeamsTeamIdCaptainRaw(requestParameters: UpdateTournamentsIdTeamsTeamIdCaptainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamOperationResponse>>;

    /**
     * Transfer team captaincy to another member (admin only)
     */
    updateTournamentsIdTeamsTeamIdCaptain(requestParameters: UpdateTournamentsIdTeamsTeamIdCaptainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamOperationResponse>;

    /**
     * Update a payout table (admin only)
     * @param {string} payoutTableId 
     * @param {UpdatePayoutTableBody} updatePayoutTableBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentsPayoutTablesPayoutTableIdRaw(requestParameters: UpdateTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayoutTableResponse>>;

    /**
     * Update a payout table (admin only)
     */
    updateTournamentsPayoutTablesPayoutTableId(requestParameters: UpdateTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayoutTableResponse>;

    /**
     * Update tournament configuration settings (admin only). Arrays are replaced atomically - send complete desired state. Use enabled:false for soft deletion.
     * @param {UpdateTournamentSettingsBody} updateTournamentSettingsBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentsSettingsRaw(requestParameters: UpdateTournamentsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSettingsResponse>>;

    /**
     * Update tournament configuration settings (admin only). Arrays are replaced atomically - send complete desired state. Use enabled:false for soft deletion.
     */
    updateTournamentsSettings(requestParameters: UpdateTournamentsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSettingsResponse>;

    /**
     * Soft-remove a captured match screenshot from the dispute evidence. Restricted to the user who uploaded it. The row is retained (admins still see it in the evidence view) but the filer\'s screenshot list and the LLM dispute adjudicator skip it — this lets a filer pull a wrong capture so it can\'t poison auto-adjudication.
     * @param {string} tournamentId Tournament ID
     * @param {string} matchId Bracket match ID
     * @param {string} photoId MatchPhotoSubmission ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetachRaw(requestParameters: UpdateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DetachMatchPhotoResponse>>;

    /**
     * Soft-remove a captured match screenshot from the dispute evidence. Restricted to the user who uploaded it. The row is retained (admins still see it in the evidence view) but the filer\'s screenshot list and the LLM dispute adjudicator skip it — this lets a filer pull a wrong capture so it can\'t poison auto-adjudication.
     */
    updateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetach(requestParameters: UpdateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DetachMatchPhotoResponse>;

    /**
     * Update team details (captain only)
     * @param {string} tournamentId 
     * @param {string} teamId 
     * @param {UpdateTeamBody} updateTeamBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentsTournamentIdTeamsTeamIdRaw(requestParameters: UpdateTournamentsTournamentIdTeamsTeamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamOperationResponse>>;

    /**
     * Update team details (captain only)
     */
    updateTournamentsTournamentIdTeamsTeamId(requestParameters: UpdateTournamentsTournamentIdTeamsTeamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamOperationResponse>;

}

/**
 * 
 */
export class TournamentsApi extends runtime.BaseAPI implements TournamentsApiInterface {

    /**
     * Create a new tournament (admin only)
     */
    async createTournamentsRaw(requestParameters: CreateTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tournament>> {
        if (requestParameters['createTournamentBody'] == null) {
            throw new runtime.RequiredError(
                'createTournamentBody',
                'Required parameter "createTournamentBody" was null or undefined when calling createTournaments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTournamentBodyToJSON(requestParameters['createTournamentBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentFromJSON(jsonValue));
    }

    /**
     * Create a new tournament (admin only)
     */
    async createTournaments(requestParameters: CreateTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tournament> {
        const response = await this.createTournamentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel a tournament and optionally refund entry fees (admin only). Rejected if the tournament has already paid out prizes; a COMPLETED tournament that paid no one is cancellable so its entry fees can be refunded.
     */
    async createTournamentsIdCancelRaw(requestParameters: CreateTournamentsIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentCancellationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTournamentsIdCancel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelTournamentBodyToJSON(requestParameters['cancelTournamentBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentCancellationResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a tournament and optionally refund entry fees (admin only). Rejected if the tournament has already paid out prizes; a COMPLETED tournament that paid no one is cancellable so its entry fees can be refunded.
     */
    async createTournamentsIdCancel(requestParameters: CreateTournamentsIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentCancellationResponse> {
        const response = await this.createTournamentsIdCancelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Duplicate an existing tournament with new timing (admin only)
     */
    async createTournamentsIdDuplicateRaw(requestParameters: CreateTournamentsIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentDuplicateResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTournamentsIdDuplicate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/duplicate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DuplicateTournamentBodyToJSON(requestParameters['duplicateTournamentBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentDuplicateResponseFromJSON(jsonValue));
    }

    /**
     * Duplicate an existing tournament with new timing (admin only)
     */
    async createTournamentsIdDuplicate(requestParameters: CreateTournamentsIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentDuplicateResponse> {
        const response = await this.createTournamentsIdDuplicateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Force forfeit a match for a team (admin only)
     */
    async createTournamentsIdMatchesMatchIdForfeitRaw(requestParameters: CreateTournamentsIdMatchesMatchIdForfeitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentArchiveResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTournamentsIdMatchesMatchIdForfeit().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsIdMatchesMatchIdForfeit().'
            );
        }

        if (requestParameters['forceForfeitBody'] == null) {
            throw new runtime.RequiredError(
                'forceForfeitBody',
                'Required parameter "forceForfeitBody" was null or undefined when calling createTournamentsIdMatchesMatchIdForfeit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/matches/{matchId}/forfeit`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForceForfeitBodyToJSON(requestParameters['forceForfeitBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentArchiveResponseFromJSON(jsonValue));
    }

    /**
     * Force forfeit a match for a team (admin only)
     */
    async createTournamentsIdMatchesMatchIdForfeit(requestParameters: CreateTournamentsIdMatchesMatchIdForfeitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentArchiveResponse> {
        const response = await this.createTournamentsIdMatchesMatchIdForfeitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start a tournament and generate brackets (admin only). Automatically locks rosters if not already locked to prevent roster changes during play.
     */
    async createTournamentsIdStartRaw(requestParameters: CreateTournamentsIdStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tournament>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTournamentsIdStart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/start`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentFromJSON(jsonValue));
    }

    /**
     * Start a tournament and generate brackets (admin only). Automatically locks rosters if not already locked to prevent roster changes during play.
     */
    async createTournamentsIdStart(requestParameters: CreateTournamentsIdStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tournament> {
        const response = await this.createTournamentsIdStartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin-create a team for seeding or placeholders (admin only)
     */
    async createTournamentsIdTeamsRaw(requestParameters: CreateTournamentsIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminSeedTeamResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTournamentsIdTeams().'
            );
        }

        if (requestParameters['adminSeedTeamBody'] == null) {
            throw new runtime.RequiredError(
                'adminSeedTeamBody',
                'Required parameter "adminSeedTeamBody" was null or undefined when calling createTournamentsIdTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/teams`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminSeedTeamBodyToJSON(requestParameters['adminSeedTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminSeedTeamResponseFromJSON(jsonValue));
    }

    /**
     * Admin-create a team for seeding or placeholders (admin only)
     */
    async createTournamentsIdTeams(requestParameters: CreateTournamentsIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminSeedTeamResponse> {
        const response = await this.createTournamentsIdTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Apply a penalty to a team (admin only)
     */
    async createTournamentsIdTeamsTeamIdPenaltyRaw(requestParameters: CreateTournamentsIdTeamsTeamIdPenaltyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PenaltyApplicationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTournamentsIdTeamsTeamIdPenalty().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling createTournamentsIdTeamsTeamIdPenalty().'
            );
        }

        if (requestParameters['applyPenaltyBody'] == null) {
            throw new runtime.RequiredError(
                'applyPenaltyBody',
                'Required parameter "applyPenaltyBody" was null or undefined when calling createTournamentsIdTeamsTeamIdPenalty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/teams/{teamId}/penalty`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplyPenaltyBodyToJSON(requestParameters['applyPenaltyBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PenaltyApplicationResponseFromJSON(jsonValue));
    }

    /**
     * Apply a penalty to a team (admin only)
     */
    async createTournamentsIdTeamsTeamIdPenalty(requestParameters: CreateTournamentsIdTeamsTeamIdPenaltyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PenaltyApplicationResponse> {
        const response = await this.createTournamentsIdTeamsTeamIdPenaltyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel a pending team invitation (admin only)
     */
    async createTournamentsInvitationsInvitationIdCancelRaw(requestParameters: CreateTournamentsInvitationsInvitationIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CancelInvitationActionResponse>> {
        if (requestParameters['invitationId'] == null) {
            throw new runtime.RequiredError(
                'invitationId',
                'Required parameter "invitationId" was null or undefined when calling createTournamentsInvitationsInvitationIdCancel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/invitations/{invitationId}/cancel`;
        urlPath = urlPath.replace(`{${"invitationId"}}`, encodeURIComponent(String(requestParameters['invitationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CancelInvitationActionResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a pending team invitation (admin only)
     */
    async createTournamentsInvitationsInvitationIdCancel(requestParameters: CreateTournamentsInvitationsInvitationIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CancelInvitationActionResponse> {
        const response = await this.createTournamentsInvitationsInvitationIdCancelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resend a team invitation (admin only). Resets expiration and can be used for expired invitations.
     */
    async createTournamentsInvitationsInvitationIdResendRaw(requestParameters: CreateTournamentsInvitationsInvitationIdResendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvitationActionResponse>> {
        if (requestParameters['invitationId'] == null) {
            throw new runtime.RequiredError(
                'invitationId',
                'Required parameter "invitationId" was null or undefined when calling createTournamentsInvitationsInvitationIdResend().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/invitations/{invitationId}/resend`;
        urlPath = urlPath.replace(`{${"invitationId"}}`, encodeURIComponent(String(requestParameters['invitationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationActionResponseFromJSON(jsonValue));
    }

    /**
     * Resend a team invitation (admin only). Resets expiration and can be used for expired invitations.
     */
    async createTournamentsInvitationsInvitationIdResend(requestParameters: CreateTournamentsInvitationsInvitationIdResendRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvitationActionResponse> {
        const response = await this.createTournamentsInvitationsInvitationIdResendRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Accept or decline a team invitation
     */
    async createTournamentsInvitationsInvitationIdRespondRaw(requestParameters: CreateTournamentsInvitationsInvitationIdRespondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamOperationResponse>> {
        if (requestParameters['invitationId'] == null) {
            throw new runtime.RequiredError(
                'invitationId',
                'Required parameter "invitationId" was null or undefined when calling createTournamentsInvitationsInvitationIdRespond().'
            );
        }

        if (requestParameters['respondToInviteBody'] == null) {
            throw new runtime.RequiredError(
                'respondToInviteBody',
                'Required parameter "respondToInviteBody" was null or undefined when calling createTournamentsInvitationsInvitationIdRespond().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/invitations/{invitationId}/respond`;
        urlPath = urlPath.replace(`{${"invitationId"}}`, encodeURIComponent(String(requestParameters['invitationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RespondToInviteBodyToJSON(requestParameters['respondToInviteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamOperationResponseFromJSON(jsonValue));
    }

    /**
     * Accept or decline a team invitation
     */
    async createTournamentsInvitationsInvitationIdRespond(requestParameters: CreateTournamentsInvitationsInvitationIdRespondRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamOperationResponse> {
        const response = await this.createTournamentsInvitationsInvitationIdRespondRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new payout table (admin only)
     */
    async createTournamentsPayoutTablesRaw(requestParameters: CreateTournamentsPayoutTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayoutTableResponse>> {
        if (requestParameters['createPayoutTableBody'] == null) {
            throw new runtime.RequiredError(
                'createPayoutTableBody',
                'Required parameter "createPayoutTableBody" was null or undefined when calling createTournamentsPayoutTables().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/payout-tables`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePayoutTableBodyToJSON(requestParameters['createPayoutTableBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PayoutTableResponseFromJSON(jsonValue));
    }

    /**
     * Create a new payout table (admin only)
     */
    async createTournamentsPayoutTables(requestParameters: CreateTournamentsPayoutTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayoutTableResponse> {
        const response = await this.createTournamentsPayoutTablesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Regenerate the tournament bracket from the current paid, active team list and seeds. Pre-play only — refuses the moment any match has readied into play or recorded a score.
     */
    async createTournamentsTournamentIdAdminRebuildBracketRaw(requestParameters: CreateTournamentsTournamentIdAdminRebuildBracketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminRebuildBracketResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdAdminRebuildBracket().'
            );
        }

        if (requestParameters['adminRebuildBracketBody'] == null) {
            throw new runtime.RequiredError(
                'adminRebuildBracketBody',
                'Required parameter "adminRebuildBracketBody" was null or undefined when calling createTournamentsTournamentIdAdminRebuildBracket().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/admin-rebuild-bracket`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminRebuildBracketBodyToJSON(requestParameters['adminRebuildBracketBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminRebuildBracketResponseFromJSON(jsonValue));
    }

    /**
     * Regenerate the tournament bracket from the current paid, active team list and seeds. Pre-play only — refuses the moment any match has readied into play or recorded a score.
     */
    async createTournamentsTournamentIdAdminRebuildBracket(requestParameters: CreateTournamentsTournamentIdAdminRebuildBracketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminRebuildBracketResponse> {
        const response = await this.createTournamentsTournamentIdAdminRebuildBracketRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolve a match dispute (admin only)
     */
    async createTournamentsTournamentIdDisputesDisputeIdResolveRaw(requestParameters: CreateTournamentsTournamentIdDisputesDisputeIdResolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DisputeResolutionResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdDisputesDisputeIdResolve().'
            );
        }

        if (requestParameters['disputeId'] == null) {
            throw new runtime.RequiredError(
                'disputeId',
                'Required parameter "disputeId" was null or undefined when calling createTournamentsTournamentIdDisputesDisputeIdResolve().'
            );
        }

        if (requestParameters['resolveDisputeBody'] == null) {
            throw new runtime.RequiredError(
                'resolveDisputeBody',
                'Required parameter "resolveDisputeBody" was null or undefined when calling createTournamentsTournamentIdDisputesDisputeIdResolve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/disputes/{disputeId}/resolve`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"disputeId"}}`, encodeURIComponent(String(requestParameters['disputeId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResolveDisputeBodyToJSON(requestParameters['resolveDisputeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DisputeResolutionResponseFromJSON(jsonValue));
    }

    /**
     * Resolve a match dispute (admin only)
     */
    async createTournamentsTournamentIdDisputesDisputeIdResolve(requestParameters: CreateTournamentsTournamentIdDisputesDisputeIdResolveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DisputeResolutionResponse> {
        const response = await this.createTournamentsTournamentIdDisputesDisputeIdResolveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Distribute prizes to tournament winners (admin only)
     */
    async createTournamentsTournamentIdDistributePrizesRaw(requestParameters: CreateTournamentsTournamentIdDistributePrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrizeDistributionResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdDistributePrizes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/distribute-prizes`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributePrizesBodyToJSON(requestParameters['distributePrizesBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrizeDistributionResponseFromJSON(jsonValue));
    }

    /**
     * Distribute prizes to tournament winners (admin only)
     */
    async createTournamentsTournamentIdDistributePrizes(requestParameters: CreateTournamentsTournamentIdDistributePrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrizeDistributionResponse> {
        const response = await this.createTournamentsTournamentIdDistributePrizesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin manually advances one of a match\'s teams into its next bracket slot — the escape hatch for a stuck pairing. Completes the match with an explicit winner and no scores. Refuses completed and disputed matches.
     */
    async createTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeamRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminAdvanceTeamResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeam().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeam().'
            );
        }

        if (requestParameters['adminAdvanceTeamBody'] == null) {
            throw new runtime.RequiredError(
                'adminAdvanceTeamBody',
                'Required parameter "adminAdvanceTeamBody" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/admin-advance-team`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminAdvanceTeamBodyToJSON(requestParameters['adminAdvanceTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminAdvanceTeamResponseFromJSON(jsonValue));
    }

    /**
     * Admin manually advances one of a match\'s teams into its next bracket slot — the escape hatch for a stuck pairing. Completes the match with an explicit winner and no scores. Refuses completed and disputed matches.
     */
    async createTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeam(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminAdvanceTeamResponse> {
        const response = await this.createTournamentsTournamentIdMatchesMatchIdAdminAdvanceTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reopen a decided match, clearing its result and unseating the winner from the next round (admin only).
     */
    async createTournamentsTournamentIdMatchesMatchIdAdminReopenRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminReopenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminReopenMatchResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminReopen().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminReopen().'
            );
        }

        if (requestParameters['adminReopenMatchBody'] == null) {
            throw new runtime.RequiredError(
                'adminReopenMatchBody',
                'Required parameter "adminReopenMatchBody" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminReopen().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/admin-reopen`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminReopenMatchBodyToJSON(requestParameters['adminReopenMatchBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminReopenMatchResponseFromJSON(jsonValue));
    }

    /**
     * Reopen a decided match, clearing its result and unseating the winner from the next round (admin only).
     */
    async createTournamentsTournamentIdMatchesMatchIdAdminReopen(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminReopenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminReopenMatchResponse> {
        const response = await this.createTournamentsTournamentIdMatchesMatchIdAdminReopenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin sets a match result directly — no dispute required. IN_PROGRESS and AWAITING_CONFIRMATION matches only; a COMPLETED match needs the (separate) reopen flow and a DISPUTED one goes through dispute resolution.
     */
    async createTournamentsTournamentIdMatchesMatchIdAdminScoreOverrideRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminScoreOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminOverrideMatchScoreResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminScoreOverride().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminScoreOverride().'
            );
        }

        if (requestParameters['adminOverrideMatchScoreBody'] == null) {
            throw new runtime.RequiredError(
                'adminOverrideMatchScoreBody',
                'Required parameter "adminOverrideMatchScoreBody" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdAdminScoreOverride().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/admin-score-override`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminOverrideMatchScoreBodyToJSON(requestParameters['adminOverrideMatchScoreBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminOverrideMatchScoreResponseFromJSON(jsonValue));
    }

    /**
     * Admin sets a match result directly — no dispute required. IN_PROGRESS and AWAITING_CONFIRMATION matches only; a COMPLETED match needs the (separate) reopen flow and a DISPUTED one goes through dispute resolution.
     */
    async createTournamentsTournamentIdMatchesMatchIdAdminScoreOverride(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdAdminScoreOverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminOverrideMatchScoreResponse> {
        const response = await this.createTournamentsTournamentIdMatchesMatchIdAdminScoreOverrideRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm the standing score for your team (team captain only). The match completes once both teams have confirmed — a manual submission counts as the submitter\'s confirmation, a machine pre-fill counts for neither.
     */
    async createTournamentsTournamentIdMatchesMatchIdConfirmRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScoreConfirmationResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdConfirm().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdConfirm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/confirm`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScoreConfirmationResponseFromJSON(jsonValue));
    }

    /**
     * Confirm the standing score for your team (team captain only). The match completes once both teams have confirmed — a manual submission counts as the submitter\'s confirmation, a machine pre-fill counts for neither.
     */
    async createTournamentsTournamentIdMatchesMatchIdConfirm(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdConfirmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScoreConfirmationResponse> {
        const response = await this.createTournamentsTournamentIdMatchesMatchIdConfirmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dispute a match score submission (team captain only)
     */
    async createTournamentsTournamentIdMatchesMatchIdDisputeRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdDisputeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchDisputeFiledResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdDispute().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdDispute().'
            );
        }

        if (requestParameters['disputeMatchBody'] == null) {
            throw new runtime.RequiredError(
                'disputeMatchBody',
                'Required parameter "disputeMatchBody" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdDispute().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/dispute`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DisputeMatchBodyToJSON(requestParameters['disputeMatchBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchDisputeFiledResponseFromJSON(jsonValue));
    }

    /**
     * Dispute a match score submission (team captain only)
     */
    async createTournamentsTournamentIdMatchesMatchIdDispute(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdDisputeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchDisputeFiledResponse> {
        const response = await this.createTournamentsTournamentIdMatchesMatchIdDisputeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Report opponent as no-show once the configured no-show window (TournamentTimerConfig.noShowWindowMinutes, default 15) has elapsed since the scheduled match time. Results in automatic forfeit.
     */
    async createTournamentsTournamentIdMatchesMatchIdNoShowRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdNoShowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NoShowReportResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdNoShow().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdNoShow().'
            );
        }

        if (requestParameters['reportNoShowBody'] == null) {
            throw new runtime.RequiredError(
                'reportNoShowBody',
                'Required parameter "reportNoShowBody" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdNoShow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/no-show`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportNoShowBodyToJSON(requestParameters['reportNoShowBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NoShowReportResponseFromJSON(jsonValue));
    }

    /**
     * Report opponent as no-show once the configured no-show window (TournamentTimerConfig.noShowWindowMinutes, default 15) has elapsed since the scheduled match time. Results in automatic forfeit.
     */
    async createTournamentsTournamentIdMatchesMatchIdNoShow(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdNoShowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NoShowReportResponse> {
        const response = await this.createTournamentsTournamentIdMatchesMatchIdNoShowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark the caller\'s team as ready for a bracket match (team captain only). When both teams are ready the match moves IN_PROGRESS and score submission opens.
     */
    async createTournamentsTournamentIdMatchesMatchIdReadyRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdReadyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadyUpTeamResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdReady().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdReady().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/ready`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadyUpTeamResponseFromJSON(jsonValue));
    }

    /**
     * Mark the caller\'s team as ready for a bracket match (team captain only). When both teams are ready the match moves IN_PROGRESS and score submission opens.
     */
    async createTournamentsTournamentIdMatchesMatchIdReady(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdReadyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadyUpTeamResponse> {
        const response = await this.createTournamentsTournamentIdMatchesMatchIdReadyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit match score (team captain only)
     */
    async createTournamentsTournamentIdMatchesMatchIdScoreRaw(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ScoreSubmissionResultResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdScore().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdScore().'
            );
        }

        if (requestParameters['submitScoreBody'] == null) {
            throw new runtime.RequiredError(
                'submitScoreBody',
                'Required parameter "submitScoreBody" was null or undefined when calling createTournamentsTournamentIdMatchesMatchIdScore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/score`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitScoreBodyToJSON(requestParameters['submitScoreBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ScoreSubmissionResultResponseFromJSON(jsonValue));
    }

    /**
     * Submit match score (team captain only)
     */
    async createTournamentsTournamentIdMatchesMatchIdScore(requestParameters: CreateTournamentsTournamentIdMatchesMatchIdScoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ScoreSubmissionResultResponse> {
        const response = await this.createTournamentsTournamentIdMatchesMatchIdScoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Participant toggles their own connected channel on for the tournament. No channel id — resolved from the caller\'s ACTIVE UserExternalIdentity. Requires the caller to be a tournament participant and the competition streamingMode to be INDIVIDUAL or BOTH.
     */
    async createTournamentsTournamentIdParticipantStreamRaw(requestParameters: CreateTournamentsTournamentIdParticipantStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettingsResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdParticipantStream().'
            );
        }

        if (requestParameters['createTournamentParticipantStreamBody'] == null) {
            throw new runtime.RequiredError(
                'createTournamentParticipantStreamBody',
                'Required parameter "createTournamentParticipantStreamBody" was null or undefined when calling createTournamentsTournamentIdParticipantStream().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/participant-stream`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTournamentParticipantStreamBodyToJSON(requestParameters['createTournamentParticipantStreamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamingSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Participant toggles their own connected channel on for the tournament. No channel id — resolved from the caller\'s ACTIVE UserExternalIdentity. Requires the caller to be a tournament participant and the competition streamingMode to be INDIVIDUAL or BOTH.
     */
    async createTournamentsTournamentIdParticipantStream(requestParameters: CreateTournamentsTournamentIdParticipantStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettingsResponse> {
        const response = await this.createTournamentsTournamentIdParticipantStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Register a new team for a tournament (creates team with user as captain)
     */
    async createTournamentsTournamentIdTeamsRaw(requestParameters: CreateTournamentsTournamentIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamRegistrationResultResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdTeams().'
            );
        }

        if (requestParameters['registerTeamBody'] == null) {
            throw new runtime.RequiredError(
                'registerTeamBody',
                'Required parameter "registerTeamBody" was null or undefined when calling createTournamentsTournamentIdTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterTeamBodyToJSON(requestParameters['registerTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamRegistrationResultResponseFromJSON(jsonValue));
    }

    /**
     * Register a new team for a tournament (creates team with user as captain)
     */
    async createTournamentsTournamentIdTeams(requestParameters: CreateTournamentsTournamentIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamRegistrationResultResponse> {
        const response = await this.createTournamentsTournamentIdTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check in a team for tournament. Must be within check-in window (startTime - checkInWindowMinutes to startTime).
     */
    async createTournamentsTournamentIdTeamsTeamIdCheckInRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdCheckInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamOperationResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdCheckIn().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdCheckIn().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}/check-in`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamOperationResponseFromJSON(jsonValue));
    }

    /**
     * Check in a team for tournament. Must be within check-in window (startTime - checkInWindowMinutes to startTime).
     */
    async createTournamentsTournamentIdTeamsTeamIdCheckIn(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdCheckInRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamOperationResponse> {
        const response = await this.createTournamentsTournamentIdTeamsTeamIdCheckInRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disqualify a team from the tournament (admin only)
     */
    async createTournamentsTournamentIdTeamsTeamIdDisqualifyRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdDisqualifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamDisqualificationResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdDisqualify().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdDisqualify().'
            );
        }

        if (requestParameters['disqualifyTeamBody'] == null) {
            throw new runtime.RequiredError(
                'disqualifyTeamBody',
                'Required parameter "disqualifyTeamBody" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdDisqualify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}/disqualify`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DisqualifyTeamBodyToJSON(requestParameters['disqualifyTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamDisqualificationResponseFromJSON(jsonValue));
    }

    /**
     * Disqualify a team from the tournament (admin only)
     */
    async createTournamentsTournamentIdTeamsTeamIdDisqualify(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdDisqualifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamDisqualificationResponse> {
        const response = await this.createTournamentsTournamentIdTeamsTeamIdDisqualifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invite a user to join the team (captain only)
     */
    async createTournamentsTournamentIdTeamsTeamIdInviteRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamInvitationResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdInvite().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdInvite().'
            );
        }

        if (requestParameters['inviteTeamMemberBody'] == null) {
            throw new runtime.RequiredError(
                'inviteTeamMemberBody',
                'Required parameter "inviteTeamMemberBody" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}/invite`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InviteTeamMemberBodyToJSON(requestParameters['inviteTeamMemberBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamInvitationResponseFromJSON(jsonValue));
    }

    /**
     * Invite a user to join the team (captain only)
     */
    async createTournamentsTournamentIdTeamsTeamIdInvite(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamInvitationResponse> {
        const response = await this.createTournamentsTournamentIdTeamsTeamIdInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Allows a user to join a team directly via an invite link. This is a self-service join - users with the invite token can add themselves to the team roster without requiring captain approval. The invite token is provided by the team captain and must be passed as a query parameter. 
     * Join a team via invite link
     */
    async createTournamentsTournamentIdTeamsTeamIdJoinRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamJoinResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdJoin().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdJoin().'
            );
        }

        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdJoin().'
            );
        }

        if (requestParameters['playerName'] == null) {
            throw new runtime.RequiredError(
                'playerName',
                'Required parameter "playerName" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdJoin().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['token'] != null) {
            queryParameters['token'] = requestParameters['token'];
        }

        if (requestParameters['playerName'] != null) {
            queryParameters['playerName'] = requestParameters['playerName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}/join`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamJoinResponseFromJSON(jsonValue));
    }

    /**
     * Allows a user to join a team directly via an invite link. This is a self-service join - users with the invite token can add themselves to the team roster without requiring captain approval. The invite token is provided by the team captain and must be passed as a query parameter. 
     * Join a team via invite link
     */
    async createTournamentsTournamentIdTeamsTeamIdJoin(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdJoinRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamJoinResponse> {
        const response = await this.createTournamentsTournamentIdTeamsTeamIdJoinRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Leave a team (cannot leave if captain without transferring captaincy)
     */
    async createTournamentsTournamentIdTeamsTeamIdLeaveRaw(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamLeaveResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdLeave().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling createTournamentsTournamentIdTeamsTeamIdLeave().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}/leave`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamLeaveResponseFromJSON(jsonValue));
    }

    /**
     * Leave a team (cannot leave if captain without transferring captaincy)
     */
    async createTournamentsTournamentIdTeamsTeamIdLeave(requestParameters: CreateTournamentsTournamentIdTeamsTeamIdLeaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamLeaveResponse> {
        const response = await this.createTournamentsTournamentIdTeamsTeamIdLeaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Join the waitlist for a full tournament (creates team on waitlist)
     */
    async createTournamentsTournamentIdWaitlistRaw(requestParameters: CreateTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentWaitlistJoinResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdWaitlist().'
            );
        }

        if (requestParameters['joinWaitlistBody'] == null) {
            throw new runtime.RequiredError(
                'joinWaitlistBody',
                'Required parameter "joinWaitlistBody" was null or undefined when calling createTournamentsTournamentIdWaitlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/waitlist`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JoinWaitlistBodyToJSON(requestParameters['joinWaitlistBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentWaitlistJoinResponseFromJSON(jsonValue));
    }

    /**
     * Join the waitlist for a full tournament (creates team on waitlist)
     */
    async createTournamentsTournamentIdWaitlist(requestParameters: CreateTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentWaitlistJoinResponse> {
        const response = await this.createTournamentsTournamentIdWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin endpoint to manually promote a team from waitlist
     */
    async createTournamentsTournamentIdWaitlistPromoteRaw(requestParameters: CreateTournamentsTournamentIdWaitlistPromoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WaitlistPromoteResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling createTournamentsTournamentIdWaitlistPromote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/waitlist/promote`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PromoteFromWaitlistBodyToJSON(requestParameters['promoteFromWaitlistBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WaitlistPromoteResponseFromJSON(jsonValue));
    }

    /**
     * Admin endpoint to manually promote a team from waitlist
     */
    async createTournamentsTournamentIdWaitlistPromote(requestParameters: CreateTournamentsTournamentIdWaitlistPromoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WaitlistPromoteResponse> {
        const response = await this.createTournamentsTournamentIdWaitlistPromoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * [DEPRECATED] Request a withdrawal from tournament wallet. Not implemented - use platform rewards instead.
     * @deprecated
     */
    async createTournamentsWalletWithdrawRaw(requestParameters: CreateTournamentsWalletWithdrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/wallet/withdraw`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RequestTournamentWithdrawalBodyToJSON(requestParameters['requestTournamentWithdrawalBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * [DEPRECATED] Request a withdrawal from tournament wallet. Not implemented - use platform rewards instead.
     * @deprecated
     */
    async createTournamentsWalletWithdraw(requestParameters: CreateTournamentsWalletWithdrawRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createTournamentsWalletWithdrawRaw(requestParameters, initOverrides);
    }

    /**
     * [DEPRECATED] Cancel a pending withdrawal request. Not implemented.
     * @deprecated
     */
    async createTournamentsWalletWithdrawalsWithdrawalIdCancelRaw(requestParameters: CreateTournamentsWalletWithdrawalsWithdrawalIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['withdrawalId'] == null) {
            throw new runtime.RequiredError(
                'withdrawalId',
                'Required parameter "withdrawalId" was null or undefined when calling createTournamentsWalletWithdrawalsWithdrawalIdCancel().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/wallet/withdrawals/{withdrawalId}/cancel`;
        urlPath = urlPath.replace(`{${"withdrawalId"}}`, encodeURIComponent(String(requestParameters['withdrawalId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelTournamentWithdrawalBodyToJSON(requestParameters['cancelTournamentWithdrawalBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * [DEPRECATED] Cancel a pending withdrawal request. Not implemented.
     * @deprecated
     */
    async createTournamentsWalletWithdrawalsWithdrawalIdCancel(requestParameters: CreateTournamentsWalletWithdrawalsWithdrawalIdCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createTournamentsWalletWithdrawalsWithdrawalIdCancelRaw(requestParameters, initOverrides);
    }

    /**
     * Archive (soft delete) a tournament (admin only). Only completed or cancelled tournaments can be archived.
     */
    async deleteTournamentsIdRaw(requestParameters: DeleteTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentArchiveResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTournamentsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentArchiveResponseFromJSON(jsonValue));
    }

    /**
     * Archive (soft delete) a tournament (admin only). Only completed or cancelled tournaments can be archived.
     */
    async deleteTournamentsId(requestParameters: DeleteTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentArchiveResponse> {
        const response = await this.deleteTournamentsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a payout table (admin only)
     */
    async deleteTournamentsPayoutTablesPayoutTableIdRaw(requestParameters: DeleteTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeletePayoutTableResponse>> {
        if (requestParameters['payoutTableId'] == null) {
            throw new runtime.RequiredError(
                'payoutTableId',
                'Required parameter "payoutTableId" was null or undefined when calling deleteTournamentsPayoutTablesPayoutTableId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/payout-tables/{payoutTableId}`;
        urlPath = urlPath.replace(`{${"payoutTableId"}}`, encodeURIComponent(String(requestParameters['payoutTableId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeletePayoutTableResponseFromJSON(jsonValue));
    }

    /**
     * Delete a payout table (admin only)
     */
    async deleteTournamentsPayoutTablesPayoutTableId(requestParameters: DeleteTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeletePayoutTableResponse> {
        const response = await this.deleteTournamentsPayoutTablesPayoutTableIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Withdraw the caller\'s team ready-up for a bracket match (team captain only). Allowed only while the match is still awaiting ready-up.
     */
    async deleteTournamentsTournamentIdMatchesMatchIdReadyRaw(requestParameters: DeleteTournamentsTournamentIdMatchesMatchIdReadyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnreadyTeamResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling deleteTournamentsTournamentIdMatchesMatchIdReady().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling deleteTournamentsTournamentIdMatchesMatchIdReady().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/ready`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnreadyTeamResponseFromJSON(jsonValue));
    }

    /**
     * Withdraw the caller\'s team ready-up for a bracket match (team captain only). Allowed only while the match is still awaiting ready-up.
     */
    async deleteTournamentsTournamentIdMatchesMatchIdReady(requestParameters: DeleteTournamentsTournamentIdMatchesMatchIdReadyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnreadyTeamResponse> {
        const response = await this.deleteTournamentsTournamentIdMatchesMatchIdReadyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Participant toggles their own connected channel off for the tournament. Removes only the caller\'s own featured stream for the given platform.
     */
    async deleteTournamentsTournamentIdParticipantStreamPlatformRaw(requestParameters: DeleteTournamentsTournamentIdParticipantStreamPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StreamingSettingsResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling deleteTournamentsTournamentIdParticipantStreamPlatform().'
            );
        }

        if (requestParameters['platform'] == null) {
            throw new runtime.RequiredError(
                'platform',
                'Required parameter "platform" was null or undefined when calling deleteTournamentsTournamentIdParticipantStreamPlatform().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/participant-stream/{platform}`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"platform"}}`, encodeURIComponent(String(requestParameters['platform'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamingSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Participant toggles their own connected channel off for the tournament. Removes only the caller\'s own featured stream for the given platform.
     */
    async deleteTournamentsTournamentIdParticipantStreamPlatform(requestParameters: DeleteTournamentsTournamentIdParticipantStreamPlatformRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StreamingSettingsResponse> {
        const response = await this.deleteTournamentsTournamentIdParticipantStreamPlatformRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a member from the team (captain only). Not allowed once tournament is IN_PROGRESS or later.
     */
    async deleteTournamentsTournamentIdTeamsTeamIdMembersUserIdRaw(requestParameters: DeleteTournamentsTournamentIdTeamsTeamIdMembersUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling deleteTournamentsTournamentIdTeamsTeamIdMembersUserId().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling deleteTournamentsTournamentIdTeamsTeamIdMembersUserId().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deleteTournamentsTournamentIdTeamsTeamIdMembersUserId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}/members/{userId}`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a member from the team (captain only). Not allowed once tournament is IN_PROGRESS or later.
     */
    async deleteTournamentsTournamentIdTeamsTeamIdMembersUserId(requestParameters: DeleteTournamentsTournamentIdTeamsTeamIdMembersUserIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTournamentsTournamentIdTeamsTeamIdMembersUserIdRaw(requestParameters, initOverrides);
    }

    /**
     * Withdraw entire team from tournament (captain only). Refunds entry fee if applicable based on refund policy.
     */
    async deleteTournamentsTournamentIdTeamsTeamIdWithdrawRaw(requestParameters: DeleteTournamentsTournamentIdTeamsTeamIdWithdrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamWithdrawResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling deleteTournamentsTournamentIdTeamsTeamIdWithdraw().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling deleteTournamentsTournamentIdTeamsTeamIdWithdraw().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}/withdraw`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamWithdrawResponseFromJSON(jsonValue));
    }

    /**
     * Withdraw entire team from tournament (captain only). Refunds entry fee if applicable based on refund policy.
     */
    async deleteTournamentsTournamentIdTeamsTeamIdWithdraw(requestParameters: DeleteTournamentsTournamentIdTeamsTeamIdWithdrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamWithdrawResponse> {
        const response = await this.deleteTournamentsTournamentIdTeamsTeamIdWithdrawRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Leave the waitlist for a tournament (removes team)
     */
    async deleteTournamentsTournamentIdWaitlistRaw(requestParameters: DeleteTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuccessMessageResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling deleteTournamentsTournamentIdWaitlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/waitlist`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessMessageResponseFromJSON(jsonValue));
    }

    /**
     * Leave the waitlist for a tournament (removes team)
     */
    async deleteTournamentsTournamentIdWaitlist(requestParameters: DeleteTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuccessMessageResponse> {
        const response = await this.deleteTournamentsTournamentIdWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of tournaments with optional filters
     */
    async getTournamentsRaw(requestParameters: GetTournamentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentsListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['bracketType'] != null) {
            queryParameters['bracketType'] = requestParameters['bracketType'];
        }

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['challengeId'] != null) {
            queryParameters['challengeId'] = requestParameters['challengeId'];
        }

        if (requestParameters['competitionId'] != null) {
            queryParameters['competitionId'] = requestParameters['competitionId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['startTimeFrom'] != null) {
            queryParameters['startTimeFrom'] = requestParameters['startTimeFrom'];
        }

        if (requestParameters['startTimeTo'] != null) {
            queryParameters['startTimeTo'] = requestParameters['startTimeTo'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['matchFormatType'] != null) {
            queryParameters['matchFormatType'] = requestParameters['matchFormatType'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['includeRegistrationClosed'] != null) {
            queryParameters['includeRegistrationClosed'] = requestParameters['includeRegistrationClosed'];
        }

        if (requestParameters['includeArchived'] != null) {
            queryParameters['includeArchived'] = requestParameters['includeArchived'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentsListResponseFromJSON(jsonValue));
    }

    /**
     * Get list of tournaments with optional filters
     */
    async getTournaments(requestParameters: GetTournamentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentsListResponse> {
        const response = await this.getTournamentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of tournament-supported games for display
     */
    async getTournamentsGamesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTournamentGamesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/games`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTournamentGamesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of tournament-supported games for display
     */
    async getTournamentsGames(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTournamentGamesResponse> {
        const response = await this.getTournamentsGamesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get tournament details by ID
     */
    async getTournamentsIdRaw(requestParameters: GetTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentDetailResponseFromJSON(jsonValue));
    }

    /**
     * Get tournament details by ID
     */
    async getTournamentsId(requestParameters: GetTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentDetailResponse> {
        const response = await this.getTournamentsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get disputes for a tournament (admin only)
     */
    async getTournamentsIdDisputesRaw(requestParameters: GetTournamentsIdDisputesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTournamentDisputesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentsIdDisputes().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/disputes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTournamentDisputesResponseFromJSON(jsonValue));
    }

    /**
     * Get disputes for a tournament (admin only)
     */
    async getTournamentsIdDisputes(requestParameters: GetTournamentsIdDisputesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTournamentDisputesResponse> {
        const response = await this.getTournamentsIdDisputesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get financial summary for a tournament (admin only)
     */
    async getTournamentsIdFinancialsRaw(requestParameters: GetTournamentsIdFinancialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinancialsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentsIdFinancials().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/financials`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinancialsResponseFromJSON(jsonValue));
    }

    /**
     * Get financial summary for a tournament (admin only)
     */
    async getTournamentsIdFinancials(requestParameters: GetTournamentsIdFinancialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinancialsResponse> {
        const response = await this.getTournamentsIdFinancialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Export tournament financial data
     */
    async getTournamentsIdFinancialsExportRaw(requestParameters: GetTournamentsIdFinancialsExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentFinancialsExportResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentsIdFinancialsExport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['format'] != null) {
            queryParameters['format'] = requestParameters['format'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/financials/export`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentFinancialsExportResponseFromJSON(jsonValue));
    }

    /**
     * Export tournament financial data
     */
    async getTournamentsIdFinancialsExport(requestParameters: GetTournamentsIdFinancialsExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentFinancialsExportResponse> {
        const response = await this.getTournamentsIdFinancialsExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all matches for a tournament (admin only). Returns the shared MatchModel reporting docs (one per bracket match, seeded at tournament start), so every playable match is visible and actionable before any score is submitted.
     */
    async getTournamentsIdMatchesRaw(requestParameters: GetTournamentsIdMatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTournamentMatchesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentsIdMatches().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/matches`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTournamentMatchesResponseFromJSON(jsonValue));
    }

    /**
     * Get all matches for a tournament (admin only). Returns the shared MatchModel reporting docs (one per bracket match, seeded at tournament start), so every playable match is visible and actionable before any score is submitted.
     */
    async getTournamentsIdMatches(requestParameters: GetTournamentsIdMatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTournamentMatchesResponse> {
        const response = await this.getTournamentsIdMatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all evidence for a match — score submissions with attribution, Overwolf verification, stored screenshots (with any dispute-adjudication parses), and disputes
     */
    async getTournamentsIdMatchesMatchIdEvidenceRaw(requestParameters: GetTournamentsIdMatchesMatchIdEvidenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EvidenceResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentsIdMatchesMatchIdEvidence().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling getTournamentsIdMatchesMatchIdEvidence().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/matches/{matchId}/evidence`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EvidenceResponseFromJSON(jsonValue));
    }

    /**
     * Get all evidence for a match — score submissions with attribution, Overwolf verification, stored screenshots (with any dispute-adjudication parses), and disputes
     */
    async getTournamentsIdMatchesMatchIdEvidence(requestParameters: GetTournamentsIdMatchesMatchIdEvidenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EvidenceResponse> {
        const response = await this.getTournamentsIdMatchesMatchIdEvidenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all transactions for a tournament (admin only)
     */
    async getTournamentsIdTransactionsRaw(requestParameters: GetTournamentsIdTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransactionsListResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentsIdTransactions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/transactions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransactionsListResponseFromJSON(jsonValue));
    }

    /**
     * Get all transactions for a tournament (admin only)
     */
    async getTournamentsIdTransactions(requestParameters: GetTournamentsIdTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransactionsListResponse> {
        const response = await this.getTournamentsIdTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of team invitations with optional filters (admin only)
     */
    async getTournamentsInvitationsRaw(requestParameters: GetTournamentsInvitationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvitationsListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['tournamentId'] != null) {
            queryParameters['tournamentId'] = requestParameters['tournamentId'];
        }

        if (requestParameters['teamId'] != null) {
            queryParameters['teamId'] = requestParameters['teamId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/invitations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationsListResponseFromJSON(jsonValue));
    }

    /**
     * Get list of team invitations with optional filters (admin only)
     */
    async getTournamentsInvitations(requestParameters: GetTournamentsInvitationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvitationsListResponse> {
        const response = await this.getTournamentsInvitationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current user\'s tournaments (active, past) and pending invitations
     */
    async getTournamentsMyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MyTournamentsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/my`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MyTournamentsResponseFromJSON(jsonValue));
    }

    /**
     * Get current user\'s tournaments (active, past) and pending invitations
     */
    async getTournamentsMy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MyTournamentsResponse> {
        const response = await this.getTournamentsMyRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all payout tables (admin only)
     */
    async getTournamentsPayoutTablesRaw(requestParameters: GetTournamentsPayoutTablesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayoutTablesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['minTeams'] != null) {
            queryParameters['minTeams'] = requestParameters['minTeams'];
        }

        if (requestParameters['maxTeams'] != null) {
            queryParameters['maxTeams'] = requestParameters['maxTeams'];
        }

        if (requestParameters['includeDefaults'] != null) {
            queryParameters['includeDefaults'] = requestParameters['includeDefaults'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/payout-tables`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayoutTablesResponseFromJSON(jsonValue));
    }

    /**
     * Get all payout tables (admin only)
     */
    async getTournamentsPayoutTables(requestParameters: GetTournamentsPayoutTablesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayoutTablesResponse> {
        const response = await this.getTournamentsPayoutTablesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific payout table
     */
    async getTournamentsPayoutTablesPayoutTableIdRaw(requestParameters: GetTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayoutTableResponse>> {
        if (requestParameters['payoutTableId'] == null) {
            throw new runtime.RequiredError(
                'payoutTableId',
                'Required parameter "payoutTableId" was null or undefined when calling getTournamentsPayoutTablesPayoutTableId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/payout-tables/{payoutTableId}`;
        urlPath = urlPath.replace(`{${"payoutTableId"}}`, encodeURIComponent(String(requestParameters['payoutTableId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PayoutTableResponseFromJSON(jsonValue));
    }

    /**
     * Get a specific payout table
     */
    async getTournamentsPayoutTablesPayoutTableId(requestParameters: GetTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayoutTableResponse> {
        const response = await this.getTournamentsPayoutTablesPayoutTableIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get enabled tournament platforms (public endpoint)
     */
    async getTournamentsPlatformsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentPlatformsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/platforms`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentPlatformsResponseFromJSON(jsonValue));
    }

    /**
     * Get enabled tournament platforms (public endpoint)
     */
    async getTournamentsPlatforms(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentPlatformsResponse> {
        const response = await this.getTournamentsPlatformsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get tournament configuration settings (admin only)
     */
    async getTournamentsSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/settings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Get tournament configuration settings (admin only)
     */
    async getTournamentsSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSettingsResponse> {
        const response = await this.getTournamentsSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get aggregate tournament stats for the admin dashboard (admin only)
     */
    async getTournamentsStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentStatsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentStatsResponseFromJSON(jsonValue));
    }

    /**
     * Get aggregate tournament stats for the admin dashboard (admin only)
     */
    async getTournamentsStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentStatsResponse> {
        const response = await this.getTournamentsStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resolve a bracket match\'s lobby view — both teams\' rosters with per-member presence, team readiness, the game\'s lobby-join instructions, (for participants only) the generated lobby name/password, and the running auto-score while the match is in progress. Host = participant1 (the team on the left).
     */
    async getTournamentsTournamentIdMatchesMatchIdLobbyRaw(requestParameters: GetTournamentsTournamentIdMatchesMatchIdLobbyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchLobbyResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling getTournamentsTournamentIdMatchesMatchIdLobby().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling getTournamentsTournamentIdMatchesMatchIdLobby().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/lobby`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchLobbyResponseFromJSON(jsonValue));
    }

    /**
     * Resolve a bracket match\'s lobby view — both teams\' rosters with per-member presence, team readiness, the game\'s lobby-join instructions, (for participants only) the generated lobby name/password, and the running auto-score while the match is in progress. Host = participant1 (the team on the left).
     */
    async getTournamentsTournamentIdMatchesMatchIdLobby(requestParameters: GetTournamentsTournamentIdMatchesMatchIdLobbyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchLobbyResponse> {
        const response = await this.getTournamentsTournamentIdMatchesMatchIdLobbyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the stored screenshots for a match. Restricted to members of the two competing teams — used by the dispute filing modal to show captured scoreboard evidence.
     */
    async getTournamentsTournamentIdMatchesMatchIdPhotosRaw(requestParameters: GetTournamentsTournamentIdMatchesMatchIdPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchPhotoListResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling getTournamentsTournamentIdMatchesMatchIdPhotos().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling getTournamentsTournamentIdMatchesMatchIdPhotos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/photos`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchPhotoListResponseFromJSON(jsonValue));
    }

    /**
     * List the stored screenshots for a match. Restricted to members of the two competing teams — used by the dispute filing modal to show captured scoreboard evidence.
     */
    async getTournamentsTournamentIdMatchesMatchIdPhotos(requestParameters: GetTournamentsTournamentIdMatchesMatchIdPhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchPhotoListResponse> {
        const response = await this.getTournamentsTournamentIdMatchesMatchIdPhotosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all teams registered for a tournament, including full roster and stats
     * Get tournament teams
     */
    async getTournamentsTournamentIdTeamsRaw(requestParameters: GetTournamentsTournamentIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentTeamsListResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling getTournamentsTournamentIdTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentTeamsListResponseFromJSON(jsonValue));
    }

    /**
     * Get all teams registered for a tournament, including full roster and stats
     * Get tournament teams
     */
    async getTournamentsTournamentIdTeams(requestParameters: GetTournamentsTournamentIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentTeamsListResponse> {
        const response = await this.getTournamentsTournamentIdTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get team details
     */
    async getTournamentsTournamentIdTeamsTeamIdRaw(requestParameters: GetTournamentsTournamentIdTeamsTeamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentTeamResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling getTournamentsTournamentIdTeamsTeamId().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling getTournamentsTournamentIdTeamsTeamId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentTeamResponseFromJSON(jsonValue));
    }

    /**
     * Get team details
     */
    async getTournamentsTournamentIdTeamsTeamId(requestParameters: GetTournamentsTournamentIdTeamsTeamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentTeamResponse> {
        const response = await this.getTournamentsTournamentIdTeamsTeamIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the waitlist for a tournament
     */
    async getTournamentsTournamentIdWaitlistRaw(requestParameters: GetTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentWaitlistResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling getTournamentsTournamentIdWaitlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/waitlist`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentWaitlistResponseFromJSON(jsonValue));
    }

    /**
     * Get the waitlist for a tournament
     */
    async getTournamentsTournamentIdWaitlist(requestParameters: GetTournamentsTournamentIdWaitlistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentWaitlistResponse> {
        const response = await this.getTournamentsTournamentIdWaitlistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s tournament transaction history (entry fees, prizes, refunds). Users may only retrieve their own history.
     */
    async getTournamentsUsersUserIdHistoryRaw(requestParameters: GetTournamentsUsersUserIdHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserTournamentHistoryResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getTournamentsUsersUserIdHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/users/{userId}/history`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserTournamentHistoryResponseFromJSON(jsonValue));
    }

    /**
     * Get a user\'s tournament transaction history (entry fees, prizes, refunds). Users may only retrieve their own history.
     */
    async getTournamentsUsersUserIdHistory(requestParameters: GetTournamentsUsersUserIdHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserTournamentHistoryResponse> {
        const response = await this.getTournamentsUsersUserIdHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a user\'s public tournament profile including aggregated stats
     */
    async getTournamentsUsersUserIdProfileRaw(requestParameters: GetTournamentsUsersUserIdProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserTournamentProfile>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getTournamentsUsersUserIdProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/users/{userId}/profile`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserTournamentProfileFromJSON(jsonValue));
    }

    /**
     * Get a user\'s public tournament profile including aggregated stats
     */
    async getTournamentsUsersUserIdProfile(requestParameters: GetTournamentsUsersUserIdProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserTournamentProfile> {
        const response = await this.getTournamentsUsersUserIdProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all tournament teams a user is a member of
     */
    async getTournamentsUsersUserIdTeamsRaw(requestParameters: GetTournamentsUsersUserIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserTournamentTeamsResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getTournamentsUsersUserIdTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/users/{userId}/teams`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserTournamentTeamsResponseFromJSON(jsonValue));
    }

    /**
     * Get all tournament teams a user is a member of
     */
    async getTournamentsUsersUserIdTeams(requestParameters: GetTournamentsUsersUserIdTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserTournamentTeamsResponse> {
        const response = await this.getTournamentsUsersUserIdTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s Fuel balance and tournament-related transaction history
     */
    async getTournamentsWalletRaw(requestParameters: GetTournamentsWalletRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WalletResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/wallet`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WalletResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s Fuel balance and tournament-related transaction history
     */
    async getTournamentsWallet(requestParameters: GetTournamentsWalletRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WalletResponse> {
        const response = await this.getTournamentsWalletRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a quick summary of user\'s Fuel balance
     */
    async getTournamentsWalletSummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WalletSummaryResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/wallet/summary`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WalletSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Get a quick summary of user\'s Fuel balance
     */
    async getTournamentsWalletSummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WalletSummaryResponse> {
        const response = await this.getTournamentsWalletSummaryRaw(initOverrides);
        return await response.value();
    }

    /**
     * [DEPRECATED] Get user\'s withdrawal request history. Not implemented.
     * @deprecated
     */
    async getTournamentsWalletWithdrawalsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/wallet/withdrawals`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * [DEPRECATED] Get user\'s withdrawal request history. Not implemented.
     * @deprecated
     */
    async getTournamentsWalletWithdrawals(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getTournamentsWalletWithdrawalsRaw(initOverrides);
    }

    /**
     * Update tournament details (admin only, limited fields after registration starts)
     */
    async updateTournamentsIdRaw(requestParameters: UpdateTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tournament>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTournamentsId().'
            );
        }

        if (requestParameters['updateTournamentBody'] == null) {
            throw new runtime.RequiredError(
                'updateTournamentBody',
                'Required parameter "updateTournamentBody" was null or undefined when calling updateTournamentsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTournamentBodyToJSON(requestParameters['updateTournamentBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentFromJSON(jsonValue));
    }

    /**
     * Update tournament details (admin only, limited fields after registration starts)
     */
    async updateTournamentsId(requestParameters: UpdateTournamentsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tournament> {
        const response = await this.updateTournamentsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reschedule a match to a new time (admin only)
     */
    async updateTournamentsIdMatchesMatchIdScheduleRaw(requestParameters: UpdateTournamentsIdMatchesMatchIdScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchScheduleResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTournamentsIdMatchesMatchIdSchedule().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling updateTournamentsIdMatchesMatchIdSchedule().'
            );
        }

        if (requestParameters['rescheduleMatchBody'] == null) {
            throw new runtime.RequiredError(
                'rescheduleMatchBody',
                'Required parameter "rescheduleMatchBody" was null or undefined when calling updateTournamentsIdMatchesMatchIdSchedule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/matches/{matchId}/schedule`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RescheduleMatchBodyToJSON(requestParameters['rescheduleMatchBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchScheduleResponseFromJSON(jsonValue));
    }

    /**
     * Reschedule a match to a new time (admin only)
     */
    async updateTournamentsIdMatchesMatchIdSchedule(requestParameters: UpdateTournamentsIdMatchesMatchIdScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchScheduleResponse> {
        const response = await this.updateTournamentsIdMatchesMatchIdScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Transfer team captaincy to another member (admin only)
     */
    async updateTournamentsIdTeamsTeamIdCaptainRaw(requestParameters: UpdateTournamentsIdTeamsTeamIdCaptainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamOperationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTournamentsIdTeamsTeamIdCaptain().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling updateTournamentsIdTeamsTeamIdCaptain().'
            );
        }

        if (requestParameters['transferCaptainBody'] == null) {
            throw new runtime.RequiredError(
                'transferCaptainBody',
                'Required parameter "transferCaptainBody" was null or undefined when calling updateTournamentsIdTeamsTeamIdCaptain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{id}/teams/{teamId}/captain`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TransferCaptainBodyToJSON(requestParameters['transferCaptainBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamOperationResponseFromJSON(jsonValue));
    }

    /**
     * Transfer team captaincy to another member (admin only)
     */
    async updateTournamentsIdTeamsTeamIdCaptain(requestParameters: UpdateTournamentsIdTeamsTeamIdCaptainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamOperationResponse> {
        const response = await this.updateTournamentsIdTeamsTeamIdCaptainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a payout table (admin only)
     */
    async updateTournamentsPayoutTablesPayoutTableIdRaw(requestParameters: UpdateTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PayoutTableResponse>> {
        if (requestParameters['payoutTableId'] == null) {
            throw new runtime.RequiredError(
                'payoutTableId',
                'Required parameter "payoutTableId" was null or undefined when calling updateTournamentsPayoutTablesPayoutTableId().'
            );
        }

        if (requestParameters['updatePayoutTableBody'] == null) {
            throw new runtime.RequiredError(
                'updatePayoutTableBody',
                'Required parameter "updatePayoutTableBody" was null or undefined when calling updateTournamentsPayoutTablesPayoutTableId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/payout-tables/{payoutTableId}`;
        urlPath = urlPath.replace(`{${"payoutTableId"}}`, encodeURIComponent(String(requestParameters['payoutTableId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePayoutTableBodyToJSON(requestParameters['updatePayoutTableBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PayoutTableResponseFromJSON(jsonValue));
    }

    /**
     * Update a payout table (admin only)
     */
    async updateTournamentsPayoutTablesPayoutTableId(requestParameters: UpdateTournamentsPayoutTablesPayoutTableIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PayoutTableResponse> {
        const response = await this.updateTournamentsPayoutTablesPayoutTableIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update tournament configuration settings (admin only). Arrays are replaced atomically - send complete desired state. Use enabled:false for soft deletion.
     */
    async updateTournamentsSettingsRaw(requestParameters: UpdateTournamentsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSettingsResponse>> {
        if (requestParameters['updateTournamentSettingsBody'] == null) {
            throw new runtime.RequiredError(
                'updateTournamentSettingsBody',
                'Required parameter "updateTournamentSettingsBody" was null or undefined when calling updateTournamentsSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/settings`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTournamentSettingsBodyToJSON(requestParameters['updateTournamentSettingsBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentSettingsResponseFromJSON(jsonValue));
    }

    /**
     * Update tournament configuration settings (admin only). Arrays are replaced atomically - send complete desired state. Use enabled:false for soft deletion.
     */
    async updateTournamentsSettings(requestParameters: UpdateTournamentsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSettingsResponse> {
        const response = await this.updateTournamentsSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft-remove a captured match screenshot from the dispute evidence. Restricted to the user who uploaded it. The row is retained (admins still see it in the evidence view) but the filer\'s screenshot list and the LLM dispute adjudicator skip it — this lets a filer pull a wrong capture so it can\'t poison auto-adjudication.
     */
    async updateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetachRaw(requestParameters: UpdateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DetachMatchPhotoResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling updateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetach().'
            );
        }

        if (requestParameters['matchId'] == null) {
            throw new runtime.RequiredError(
                'matchId',
                'Required parameter "matchId" was null or undefined when calling updateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetach().'
            );
        }

        if (requestParameters['photoId'] == null) {
            throw new runtime.RequiredError(
                'photoId',
                'Required parameter "photoId" was null or undefined when calling updateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetach().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/tournaments/{tournamentId}/matches/{matchId}/photos/{photoId}/detach`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"matchId"}}`, encodeURIComponent(String(requestParameters['matchId'])));
        urlPath = urlPath.replace(`{${"photoId"}}`, encodeURIComponent(String(requestParameters['photoId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DetachMatchPhotoResponseFromJSON(jsonValue));
    }

    /**
     * Soft-remove a captured match screenshot from the dispute evidence. Restricted to the user who uploaded it. The row is retained (admins still see it in the evidence view) but the filer\'s screenshot list and the LLM dispute adjudicator skip it — this lets a filer pull a wrong capture so it can\'t poison auto-adjudication.
     */
    async updateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetach(requestParameters: UpdateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetachRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DetachMatchPhotoResponse> {
        const response = await this.updateTournamentsTournamentIdMatchesMatchIdPhotosPhotoIdDetachRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update team details (captain only)
     */
    async updateTournamentsTournamentIdTeamsTeamIdRaw(requestParameters: UpdateTournamentsTournamentIdTeamsTeamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamOperationResponse>> {
        if (requestParameters['tournamentId'] == null) {
            throw new runtime.RequiredError(
                'tournamentId',
                'Required parameter "tournamentId" was null or undefined when calling updateTournamentsTournamentIdTeamsTeamId().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling updateTournamentsTournamentIdTeamsTeamId().'
            );
        }

        if (requestParameters['updateTeamBody'] == null) {
            throw new runtime.RequiredError(
                'updateTeamBody',
                'Required parameter "updateTeamBody" was null or undefined when calling updateTournamentsTournamentIdTeamsTeamId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tournaments/{tournamentId}/teams/{teamId}`;
        urlPath = urlPath.replace(`{${"tournamentId"}}`, encodeURIComponent(String(requestParameters['tournamentId'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTeamBodyToJSON(requestParameters['updateTeamBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamOperationResponseFromJSON(jsonValue));
    }

    /**
     * Update team details (captain only)
     */
    async updateTournamentsTournamentIdTeamsTeamId(requestParameters: UpdateTournamentsTournamentIdTeamsTeamIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamOperationResponse> {
        const response = await this.updateTournamentsTournamentIdTeamsTeamIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const DeleteTournamentsTournamentIdParticipantStreamPlatformPlatformEnum = {
    Twitch: 'TWITCH',
    Kick: 'KICK',
    Youtube: 'YOUTUBE'
} as const;
export type DeleteTournamentsTournamentIdParticipantStreamPlatformPlatformEnum = typeof DeleteTournamentsTournamentIdParticipantStreamPlatformPlatformEnum[keyof typeof DeleteTournamentsTournamentIdParticipantStreamPlatformPlatformEnum];
/**
 * @export
 */
export const GetTournamentsSortEnum = {
    StartTime: 'startTime',
    RegisteredTeamsCount: 'registeredTeamsCount',
    EntryFee: 'entryFee',
    CreatedAt: 'createdAt',
    Name: 'name'
} as const;
export type GetTournamentsSortEnum = typeof GetTournamentsSortEnum[keyof typeof GetTournamentsSortEnum];
/**
 * @export
 */
export const GetTournamentsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetTournamentsOrderEnum = typeof GetTournamentsOrderEnum[keyof typeof GetTournamentsOrderEnum];
/**
 * @export
 */
export const GetTournamentsMatchFormatTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;
export type GetTournamentsMatchFormatTypeEnum = typeof GetTournamentsMatchFormatTypeEnum[keyof typeof GetTournamentsMatchFormatTypeEnum];
/**
 * @export
 */
export const GetTournamentsIdFinancialsExportFormatEnum = {
    Json: 'json',
    Csv: 'csv'
} as const;
export type GetTournamentsIdFinancialsExportFormatEnum = typeof GetTournamentsIdFinancialsExportFormatEnum[keyof typeof GetTournamentsIdFinancialsExportFormatEnum];
/**
 * @export
 */
export const GetTournamentsIdTransactionsTypeEnum = {
    EntryFee: 'entry_fee',
    Refund: 'refund',
    Prize: 'prize',
    Penalty: 'penalty'
} as const;
export type GetTournamentsIdTransactionsTypeEnum = typeof GetTournamentsIdTransactionsTypeEnum[keyof typeof GetTournamentsIdTransactionsTypeEnum];
